// //echoshine
// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Card,
//     CardContent,
//     Typography,
//     Avatar,
//     Rating,
//     Button,
//     Checkbox,
//     FormControlLabel,
//     MenuItem,
//     Select,
//     FormControl,
//     Stack,
//     IconButton,
//     Snackbar,
//     Alert,
//     Grid,
//     Dialog,
//     DialogContent,
//     DialogTitle,
//     Divider,
//     Paper,
//     Modal,
//     Tabs,
//     Tab
// } from '@mui/material';
// import CheckIcon from '@mui/icons-material/Check';
// import { useNavigate } from 'react-router-dom';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { getAllDoctors, getDoctorSlots } from '../../service/doctor';
// import StarIcon from '@mui/icons-material/Star';
// import { Chip } from '@mui/material';
// import VideocamIcon from '@mui/icons-material/Videocam';
// import BusinessIcon from '@mui/icons-material/Business';
// import CloseIcon from '@mui/icons-material/Close';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import PersonIcon from '@mui/icons-material/Person';
// import { PhoneCallback } from '@mui/icons-material';
// import { listFamilyMembers } from '../../service/familyMemberService';
// import { createAppointment } from '../../service/appointment';
// import { getUserById } from '../../service/user';
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
// import SendIcon from '@mui/icons-material/Send';
// import { trackCTA } from '../../service/usercta';

// // ============== DOCTOR AVATAR COMPONENT ==============
// const DoctorAvatar = ({
//     doctor,
//     size = 60,
//     borderRadius = '50%',
//     showFallback = true
// }) => {
//     const [imageError, setImageError] = useState(false);

//     // 🎯 Map special IDs to specific images in public/photos
//     const getSpecialImage = () => {
//         if (doctor?.id === 11) return `/photos/Sandesh.jpeg`;
//         if (doctor?.id === 12) return `/photos/Bindu-Kulkarni.jpeg`;
//         if (doctor?.id === 13) return `/photos/Rohit-Malve.jpeg`;
//         if (doctor?.id === 14) return `/photos/Anupam-Tiwari.jpeg`;

//         return null;
//     };

//     // 🎨 Fallback color generator
//     const getFallbackColor = () => {
//         const colors = {
//             4: '#FF6B6B',
//             5: '#7B68EE',
//             6: '#9C27B0',
//             11: '#FF5722',
//             12: '#4CAF50',
//             15: '#2196F3',
//             16: '#FF9800',
//             17: '#795548',
//             18: '#607D8B',
//             19: '#E91E63',
//         };
//         return colors[doctor?.id] || '#9E9E9E';
//     };

//     const getInitials = () => {
//         if (!doctor?.name) return '?';
//         return doctor.name
//             .split(' ')
//             .map((n) => n[0])
//             .join('')
//             .toUpperCase()
//             .slice(0, 2);
//     };

//     // 🖼️ Determine image URL
//     // const getImageUrl = () => {
//     //     const specialImage = getSpecialImage();
//     //     if (specialImage) return specialImage;

//     //     if (!doctor?.avatar) return null;
//     //     return doctor.avatar.startsWith('http')
//     //         ? doctor.avatar
//     //         : `${process.env.PUBLIC_URL}${doctor.avatar}`;
//     // };
//     const getImageUrl = () => {
//         const specialImage = getSpecialImage();
//         if (specialImage) return specialImage;

//         if (!doctor?.avatar) return null;
//         return doctor.avatar.startsWith('http')
//             ? doctor.avatar
//             : `${import.meta.env.BASE_URL}${doctor.avatar.replace(/^\//, '')}`;
//     };
//     const handleImageError = () => {
//         console.error('Failed to load avatar for:', doctor?.name);
//         setImageError(true);
//     };

//     const imageUrl = getImageUrl();

//     // 🧩 Render logic
//     if (imageUrl && !imageError) {
//         return (
//             <Avatar
//                 src={imageUrl}
//                 alt={doctor.name}
//                 onError={handleImageError}
//                 sx={{
//                     width: size,
//                     height: borderRadius === 2 ? size * 1.25 : size,
//                     borderRadius: borderRadius,
//                     bgcolor: 'transparent',
//                     border: '1px solid #e0e0e0',
//                     '& .MuiAvatar-img': { objectFit: 'cover' },
//                 }}
//             />
//         );
//     }

//     // 🧍Fallback initials
//     return (
//         <Avatar
//             sx={{
//                 width: size,
//                 height: borderRadius === 2 ? size * 1.25 : size,
//                 borderRadius: borderRadius,
//                 bgcolor: getFallbackColor(),
//                 fontSize: size > 60 ? '2rem' : '1.2rem',
//                 fontWeight: 'bold',
//             }}
//         >
//             {getInitials()}
//         </Avatar>
//     );
// };


// // ============== MAIN APPOINTMENT BOOKING COMPONENT ==============
// const AppointmentBooking = ({ doctorId }) => {
//     const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
//     const userId = (localStorage.getItem("user_id") !== "null" && localStorage.getItem("user_id")) || storedUser?.id;
//     const account_id = (localStorage.getItem("account_id") !== "null" && localStorage.getItem("account_id")) || storedUser?.account_id;

//     const [doctors, setDoctors] = useState([]);
//     const [selectedDoctor, setSelectedDoctor] = useState(null);
//     const [recentVisits, setRecentVisits] = useState([]);
//     const [showBookingForm, setShowBookingForm] = useState(false);
//     const [selectedDate, setSelectedDate] = useState("");
//     const [availability, setAvailability] = useState([]);
//     const [slots, setSlots] = useState([]);
//     const [selectedSlot, setSelectedSlot] = useState(null);
//     const [selectedSessionType, setSelectedSessionType] = useState(null);
//     const [accepted, setAccepted] = useState(false);
//     const [openModal, setOpenModal] = useState(false);
//     const [tabValue, setTabValue] = useState(0);
//     const [selectedCategories, setSelectedCategories] = useState(['All']);
//     const [mobileValidationOpen, setMobileValidationOpen] = useState(false);
//     const [userData, setUserData] = useState({});

//     // Dynamically generate categories from all doctors' specialties
//     const categories = React.useMemo(() => {
//         if (!doctors || doctors.length === 0) {
//             console.log('No doctors available for categories');
//             return ['All'];
//         }

//         console.log('Generating categories from doctors:', doctors);
//         const allSpecialties = new Set();

//         doctors.forEach(doctor => {
//             console.log('Doctor data:', doctor);
//             // Check for specialties field (could be named differently)
//             const specialtiesText = doctor.specialties || doctor.specialization || doctor.specialty || '';

//             if (specialtiesText) {
//                 const specs = specialtiesText.split(',');
//                 specs.forEach(specialty => {
//                     const trimmed = specialty.trim();
//                     if (trimmed) {
//                         allSpecialties.add(trimmed);
//                     }
//                 });
//             }
//         });

//         const result = ['All', ...Array.from(allSpecialties).sort()];
//         console.log('Generated categories:', result);
//         console.log('Total unique specialties found:', allSpecialties.size);
//         return result;
//     }, [doctors]);

//     // Chat states
//     const [chatOpen, setChatOpen] = useState(false);
//     const [chatDoctor, setChatDoctor] = useState(null);
//     const [chatMessages, setChatMessages] = useState([]);
//     const [chatInput, setChatInput] = useState('');
//     const [chatTyping, setChatTyping] = useState(false);
//     const chatEndRef = React.useRef(null);

//     // New states for modals
//     const [profileModalOpen, setProfileModalOpen] = useState(false);
//     const [bookingModalOpen, setBookingModalOpen] = useState(false);
//     const [modalDoctor, setModalDoctor] = useState(null);
//     const [familyData, setFamilyData] = useState([]);
//     const [availableDates, setAvailableDates] = useState([]); // stores dates as "YYYY-MM-DD"
//     // const [userData, setUserData] = useState({});
//     const [doctorData, setDoctorData] = useState(null);
//     const today = new Date();
//     const [currentMonth, setCurrentMonth] = useState(today.getMonth());
//     const [currentYear, setCurrentYear] = useState(today.getFullYear());
//     const [slotsByDate, setSlotsByDate] = useState({});
//     const [slotsForSelectedDate, setSlotsForSelectedDate] = useState([]);

//     useEffect(() => {
//         const fetchDoctors = async () => {
//             try {
//                 const data = await getAllDoctors(userId, account_id);       // pass it to service
//                 setDoctors(data?.doctors);
//                 setRecentVisits(data?.recent_appointments);
//             } catch (err) {
//                 console.error("Failed to load doctors:", err);
//             }
//         };

//         fetchDoctors();
//     }, [userId]);

//     // useEffect(() => {
//     //     if (!showBookingForm) return;

//     //     const fetchDoctorById = async () => {
//     //         try {
//     //             const data = await getDoctorById(selectedDoctor?.id);
//     //             setDoctorData(data.doctor);
//     //         } catch (err) {
//     //             console.error("Failed to load doctor:", err);
//     //         }
//     //     };

//     //     fetchDoctorById();
//     // }, [showBookingForm, selectedDoctor?.id]);

//     const goToNextMonth = () => {
//         if (currentMonth === 11) {
//             setCurrentMonth(0);
//             setCurrentYear(prev => prev + 1);
//         } else {
//             setCurrentMonth(prev => prev + 1);
//         }
//     };

//     const goToPrevMonth = () => {
//         // ✅ Only allow previous if not current month/year
//         if (currentYear > today.getFullYear() || (currentYear === today.getFullYear() && currentMonth > today.getMonth())) {
//             if (currentMonth === 0) {
//                 setCurrentMonth(11);
//                 setCurrentYear(prev => prev - 1);
//             } else {
//                 setCurrentMonth(prev => prev - 1);
//             }
//         }
//     };

//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'success',
//     });

//     const handleClose = (event, reason) => {
//         if (reason === 'clickaway') return;
//         setSnackbar(prev => ({ ...prev, open: false }));
//     };

//     const [formData, setFormData] = useState({
//         full_name: "",
//         age: "",
//         gender: "",
//         marital_status: "",
//         phone: "",
//         email: "",
//         date: "",
//         time: "",
//         consultation_type: "",
//         consulting_type: "self",
//         dr_name: "",
//         doctor_id: "",
//         slots: "",
//         weekly_availability: "",
//         family_id: "",
//         start_time: "",
//         end_time: "",
//     });

//     const navigate = useNavigate();
//     const [user, setUser] = useState(null);

//     const isSlotDisabled = (slot) => {
//         const now = new Date();
//         const minTime = new Date(now.getTime() + 2 * 60 * 60 * 1000); // 2-hour buffer

//         // echoshine's slot objects don't always carry their own date,
//         // so fall back to the currently selected date
//         const slotDateStr = slot.slot_date ? slot.slot_date.split("T")[0] : selectedDate;
//         const slotDateTime = new Date(`${slotDateStr}T${slot.start_time}`);

//         return slotDateTime < minTime;
//     };

//     const formatNextAvailability = (nextAvailableSlot) => {
//         if (!nextAvailableSlot || !nextAvailableSlot.slot_date || !nextAvailableSlot.start_time) {
//             return "Not available";
//         }

//         try {
//             // Parse date and time properly
//             const slotDate = new Date(nextAvailableSlot.slot_date);
//             const [hours, minutes] = nextAvailableSlot.start_time.split(":");

//             // Merge date + time for local timezone
//             slotDate.setHours(parseInt(hours), parseInt(minutes));

//             // Format nicely: e.g. "31 Oct 2025, 01:00 PM"
//             return slotDate.toLocaleString("en-IN", {
//                 day: "2-digit",
//                 month: "short",
//                 year: "numeric",
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 hour12: true,
//             });
//         } catch (err) {
//             console.error("Error formatting next availability:", err);
//             return "-";
//         }
//     };

//     // Load user from localStorage on mount
//     useEffect(() => {
//         const storedUser = localStorage.getItem("user");
//         if (storedUser) {
//             setUser(JSON.parse(storedUser));
//         }
//     }, []);

//     // Update form fields when consulting_type changes
//     useEffect(() => {
//         if (formData.consulting_type === "self" && user) {

//             setFormData((prev) => ({
//                 ...prev,
//                 full_name: user.name || "",
//                 age: user.age || "",
//                 gender: user.gender || "",
//                 marital_status: user.marital_status || "",
//             }));
//         } else if (formData.consulting_type === "someone_else") {
//             setFormData((prev) => ({
//                 ...prev,
//                 full_name: "",
//                 age: "",
//                 gender: "",
//                 marital_status: "",
//             }));
//         }
//     }, [formData.consulting_type, user]);

//     // useEffect(() => {
//     //     if (userId && showBookingForm) {
//     //         const fetchData = async () => {
//     //             try {
//     //                 const family = await listFamilyMembers(userId);
//     //                 setFamilyData(family);
//     //             } catch (err) {
//     //                 console.error("Failed to fetch family members:", err);
//     //             }

//     //             try {
//     //                 const userDetails = await getUserById(userId);
//     //                 setUserData(userDetails);
//     //             } catch (err) {
//     //                 console.error("Failed to fetch user details:", err);
//     //             }
//     //         };

//     //         fetchData();
//     //     }
//     // }, [userId, showBookingForm]);

//     // Run once when component mounts or when userData is available
//     useEffect(() => {
//         if (userId && showBookingForm) {
//             const fetchData = async () => {
//                 try {
//                     const family = await listFamilyMembers(userId);
//                     setFamilyData(family);
//                 } catch (err) {
//                     console.error("Failed to fetch family members:", err);
//                 }

//                 try {
//                     const userDetails = await getUserById(userId);
//                     setUserData(userDetails);
//                 } catch (err) {
//                     console.error("Failed to fetch user details:", err);
//                 }
//             };

//             fetchData();
//         }
//     }, [userId, showBookingForm]);

//     useEffect(() => {
//         if (formData.consulting_type === "self" && userData) {
//             setFormData((prev) => ({
//                 ...prev,
//                 consulting_type: "self",
//                 gender: userData.gender
//                     ? userData.gender.charAt(0).toUpperCase() + userData.gender.slice(1).toLowerCase()
//                     : "",
//                 marital_status: userData.marital_status || "",
//                 age: userData.age || "",
//                 email: userData.email || "",
//                 phone: userData.phone || "",
//                 name: userData.name || "",
//             }));
//         }
//     }, [userData]); // run when userData is loaded

//     // New modal handlers
//     const handleViewProfile = (doctor) => {
//         setModalDoctor(doctor);
//         setProfileModalOpen(true);
//     };

//     // const handleBookAppointment = (doctor) => {
//     //     // 🔥 Track CTA event
//     //     const storedUser = localStorage.getItem('user');
//     //     const user = storedUser ? JSON.parse(storedUser) : null;

//     //     if (user && user.id) {
//     //         trackCTA('book_appointment', user, window.location.pathname);
//     //         console.log("✅ CTA tracked: book_appointment");
//     //     }

//     //     setModalDoctor(doctor);
//     //     setSelectedDoctor(doctor);
//     //     setFormData(prev => ({
//     //         ...prev,
//     //         doctor_id: doctor.id,
//     //         dr_name: doctor.name || "",
//     //     }));
//     //     setBookingModalOpen(false);
//     // };

//     const handleBookAppointment = (doctor) => {
//         // 🔥 Track CTA event
//         const storedUser = localStorage.getItem("user");
//         const parsedUser = storedUser ? JSON.parse(storedUser) : null;
//         const userId = localStorage.getItem("user_id") || parsedUser?.id || "";
//         console.log("userId at click time:", userId); // 👈 check this in console

//         if (user && user.id) {
//             trackCTA('book_appointment', user, window.location.pathname);
//             console.log("✅ CTA tracked: book_appointment");
//         }

//         setModalDoctor(doctor);
//         setSelectedDoctor(doctor);
//         setSelectedSessionType(null);
//         setFormData(prev => ({
//             ...prev,
//             doctor_id: doctor.id,
//             dr_name: doctor.name || "",
//         }));
//         setBookingModalOpen(false);

//         // Fetch user data as soon as doctor is selected so enable_ivr is
//         // available for the session type selection screen
//         if (userId) {
//             getUserById(userId).then(userDetails => {
//                 setUserData(userDetails);
//             }).catch(err => {
//                 console.error("Failed to fetch user details:", err);
//             });
//         }
//     };

//     const handleMobileValidationClose = () => {
//         setMobileValidationOpen(false);
//     };

//     const handleGoToProfile = () => {
//         window.location.href = '/profile';
//     };

//     const handleCloseProfileModal = () => {
//         setProfileModalOpen(false);
//         setModalDoctor(null);
//     };

//     const handleCloseBookingModal = () => {
//         setBookingModalOpen(false);
//         setModalDoctor(null);
//         setSelectedSessionType(null);
//     };

//     // Chat handlers
//     // const handleOpenChat = (doctor) => {
//     //     setChatDoctor(doctor);
//     //     setChatMessages([
//     //         {
//     //             from: 'bot',
//     //             text: `Welcome! 💜 You're now connected with ${doctor?.name}. This is a safe and confidential space. How can I help you today?`,
//     //         },
//     //     ]);
//     //     setChatInput('');
//     //     setChatOpen(true);
//     // };

//     const handleCloseChat = () => {
//         setChatOpen(false);
//         setChatDoctor(null);
//         setChatMessages([]);
//         setChatInput('');
//     };

//     const counsellorResponses = [
//         "I hear you, and I want you to know that what you're feeling is completely valid. Can you tell me more about what's been on your mind?",
//         "Thank you for sharing that with me. It takes courage to open up. Let's explore this together — what do you think triggered these feelings?",
//         "That sounds really challenging. Remember, it's okay to not have all the answers right now. What would feel most supportive for you at this moment?",
//         "I appreciate you trusting me with this. Many people experience similar feelings. Have you noticed any patterns in when these feelings come up?",
//         "You're doing great by reaching out. Self-awareness is the first step toward positive change. What coping strategies have you tried so far?",
//         "I understand. Let's take this one step at a time. Would you like to try a quick grounding exercise together, or would you prefer to keep talking?",
//         "That's a really insightful observation about yourself. How does it feel to acknowledge that?",
//         "It's completely normal to feel that way. Let's work through this together. What would a good outcome look like for you?",
//     ];

//     const handleSendChat = () => {
//         const trimmed = chatInput.trim();
//         if (!trimmed) return;

//         setChatMessages((prev) => [...prev, { from: 'user', text: trimmed }]);
//         setChatInput('');
//         setChatTyping(true);

//         setTimeout(() => {
//             const response = counsellorResponses[Math.floor(Math.random() * counsellorResponses.length)];
//             setChatMessages((prev) => [...prev, { from: 'bot', text: response }]);
//             setChatTyping(false);
//         }, 1200 + Math.random() * 800);
//     };

//     // Scroll chat to bottom on new messages
//     React.useEffect(() => {
//         if (chatEndRef.current) {
//             chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         }
//     }, [chatMessages, chatTyping]);

//     const handleBackToList = () => {
//         setShowBookingForm(false);
//         setSelectedDoctor(null);
//         setSelectedSessionType(null);
//         setSelectedDate(null);
//         setSelectedSlot(null);
//     };

//     useEffect(() => {
//         if (availability.length > 0) {
//             const newSlots = [];
//             availability.forEach((slot) => {
//                 const start = new Date(`1970-01-01T${slot.start_time}`);
//                 const end = new Date(`1970-01-01T${slot.end_time}`);
//                 let current = new Date(start);

//                 while (current < end) {
//                     const next = new Date(current.getTime() + 30 * 60000);
//                     if (next <= end) {
//                         newSlots.push(
//                             `${current.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${next.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
//                         );
//                     }
//                     current = next;
//                 }
//             });
//             setSlots(newSlots);
//         } else {
//             setSlots([]);
//         }
//     }, [availability]);

//     const formatSlotToAMPM = (slot) => {
//         if (!slot) return ""; // safety check

//         const [start, end] = slot.split("-"); // split by "-" instead of " - "
//         if (!start || !end) return slot; // fallback if split fails

//         const formatTime = (time24) => {
//             const [hourStr, minute] = time24.split(":");
//             let hour = parseInt(hourStr, 10);
//             const ampm = hour >= 12 ? "PM" : "AM";
//             hour = hour % 12;
//             if (hour === 0) hour = 12;
//             return `${hour}:${minute} ${ampm}`;
//         };

//         return `${formatTime(start)} - ${formatTime(end)}`;
//     };

//     const formatTime = (timeStr) => {
//         const [hour, minute] = timeStr.split(":").map(Number);
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const h = hour % 12 === 0 ? 12 : hour % 12;
//         return `${h.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")} ${ampm}`;
//     };

//     const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
//     const lastDateOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
//     const days = Array.from({ length: lastDateOfMonth }, (_, i) => i + 1);

//     useEffect(() => {
//         if (selectedDoctor?.id && showBookingForm) {
//             const fetchSlots = async () => {
//                 // const startDate = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-01`;
//                 const today = new Date();
//                 // const startDate = today.toISOString().split("T")[0];
//                 const startDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
//                 const endDate = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(lastDateOfMonth).padStart(2, "0")}`;

//                 try {
//                     const data = await getDoctorSlots(selectedDoctor?.id, startDate, endDate, false);
//                     console.log("SLOTS API RESPONSE:", data);

//                     // ✅ Extract date list from slots_by_date keys
//                     const availableDates = Object.keys(data?.slots_by_date || {})
//                         .map(date => date.split("T")[0]); // remove time part

//                     setAvailableDates(availableDates);
//                     setSlotsByDate(data?.slots_by_date || {});

//                 } catch (err) {
//                     console.error(err);
//                 }
//             };

//             fetchSlots();
//         }
//     }, [currentMonth, currentYear, selectedDoctor?.id, lastDateOfMonth, showBookingForm]);

//     //select dates automatically when available dates are fetched
//     // useEffect(() => {
//     //     if (availableDates.length > 0) {
//     //         const firstDate = availableDates[0];
//     //         setSelectedDate(firstDate);

//     //         setFormData(prev => ({
//     //             ...prev,
//     //             date: firstDate,
//     //         }));

//     //         const dateKey = Object.keys(slotsByDate).find(d => d.startsWith(firstDate));
//     //         const slots = dateKey ? slotsByDate[dateKey] : [];

//     //         setSlotsForSelectedDate(slots); // store objects instead of formatted strings

//     //         // Select first slot by default
//     //         if (slots.length > 0) {
//     //             const firstSlot = slots[0];
//     //             setSelectedSlot(firstSlot); // full object

//     //             setFormData(prev => ({
//     //                 ...prev,
//     //                 start_time: firstSlot.start_time,
//     //                 end_time: firstSlot.end_time,
//     //                 slot_id: firstSlot.id, // <-- add slot_id here
//     //             }));
//     //         }

//     //     } else {
//     //         setSelectedDate("");
//     //         setSlotsForSelectedDate([]);
//     //         setSelectedSlot(null);
//     //         setFormData(prev => ({
//     //             ...prev,
//     //             date: "",
//     //             start_time: "",
//     //             end_time: "",
//     //             slot_id: null, // reset slot_id
//     //         }));
//     //     }
//     // }, [availableDates, slotsByDate]);

//     // Reset when the doctor changes, so nothing carries over from a previous selection
//     useEffect(() => {
//         setSelectedDate("");
//         setSelectedSlot(null);
//         setSlotsForSelectedDate([]);
//         setFormData(prev => ({
//             ...prev,
//             consulting_type: "self",
//             date: "",
//             start_time: "",
//             end_time: "",
//             slot_id: null,
//         }));
//     }, [selectedDoctor?.id]);

//     // Reset when the month changes
//     useEffect(() => {
//         setSelectedDate("");
//         setSlotsForSelectedDate([]);
//         setSelectedSlot(null);
//         setAvailableDates([]);
//     }, [currentMonth, currentYear]);

//     // Clear everything if there are no available dates
//     useEffect(() => {
//         if (availableDates.length === 0) {
//             setSelectedDate("");
//             setSlotsForSelectedDate([]);
//             setSelectedSlot(null);
//             setFormData(prev => ({
//                 ...prev,
//                 date: "",
//                 start_time: "",
//                 end_time: "",
//                 slot_id: null,
//             }));
//         }
//     }, [availableDates, slotsByDate, currentMonth, currentYear]);


//     useEffect(() => {
//         if (slotsForSelectedDate.length === 0) {
//             setSelectedSlot(null);
//             setFormData(prev => ({
//                 ...prev,
//                 start_time: "",
//                 end_time: "",
//                 slot_id: null,
//             }));
//         }
//     }, [slotsForSelectedDate]);



//     // useEffect(() => {
//     //     if (slotsForSelectedDate.length > 0) {
//     //         const firstSlot = slotsForSelectedDate[0];
//     //         setSelectedSlot(firstSlot);
//     //         setFormData(prev => ({
//     //             ...prev,
//     //             start_time: firstSlot.start_time,
//     //             end_time: firstSlot.end_time,
//     //             slot_id: firstSlot.id,
//     //         }));
//     //     } else {
//     //         setSelectedSlot("");
//     //         setFormData(prev => ({
//     //             ...prev,
//     //             start_time: "",
//     //             end_time: "",
//     //             slot_id: null,
//     //         }));
//     //     }
//     // }, [slotsForSelectedDate]);





//     // const handleSubmit = async () => {
//     //     // Build the request body from formData

//     //     const currentYear = new Date().getFullYear();

//     //     const derivedDob =
//     //         userData?.dob ||
//     //         (formData?.age
//     //             ? `${currentYear - Number(formData.age)}-01-01`
//     //             : null);

//     //     console.log("age", userId, formData.family_id)
//     //     const storedUser = localStorage.getItem('user');
//     //     const localUser = storedUser ? JSON.parse(storedUser) : null;
//     //     const appointmentData = {
//     //         app_name: "echobuddy",
//     //         account_id: Number(account_id),
//     //         app_user_id: formData.consulting_type === "self" ? userId : `${Number(userId)}-${Number(formData.family_id)}`,
//     //         name: formData.consulting_type === "self"
//     //             ? (userData?.name || localUser?.name || formData?.name || formData?.full_name)
//     //             : (formData?.full_name || formData?.name),
//     //         email: formData.email || userData?.email || localUser?.email || "",
//     //         phone: formData.phone || userData?.phone || localUser?.phone || "",
//     //         address: userData?.address,
//     //         dob: derivedDob,
//     //         age: formData?.age,
//     //         gender: formData?.gender,
//     //         marital_status: formData?.marital_status,
//     //         photo: userData?.photo,
//     //         doctor_id: formData.doctor_id,
//     //         slot_id: formData.slot_id,
//     //         consultation_type: formData.consultation_type,
//     //     };
//     //     console.log("appointmentData", appointmentData)

//     //     try {
//     //         const result = await createAppointment(appointmentData);
//     //         console.log("Appointment created:", result);
//     //         if (window.confirm("Appointment created successfully!")) {
//     //             navigate("/home"); // ✅ only if OK is clicked
//     //         }
//     //     } catch (err) {
//     //         console.error("Failed to create appointment", err);
//     //         alert("Failed to create appointment");
//     //     }
//     // };
//     const handleSubmit = async () => {
//         // ...validation checks stay the same...

//         const currentYear = new Date().getFullYear();
//         const derivedDob = userData?.dob
//             ? userData.dob.split("T")[0]
//             : (formData?.age ? `${currentYear - Number(formData.age)}-01-01` : null);

//         // ✅ single source of truth — no re-parsing localStorage here
//         const resolvedUserId = userData?.id || userId; // userId = top-level component var
//         const resolvedAccountId = userData?.account_id || account_id;

//         const appointmentData = {
//             app_name: "echoshine",
//             user_id: Number(resolvedUserId),
//             account_id: Number(resolvedAccountId),
//             customer_id: Number(resolvedUserId),   // ✅ add this

//             // app_user_id:
//             //     formData.consulting_type === "self"
//             //         ? resolvedUserId
//             //         : `${Number(resolvedUserId)}-${Number(formData.family_id)}`,
//             app_user_id:
//                 formData.consulting_type === "self"
//                     ? String(resolvedUserId)
//                     : `${resolvedUserId}-${formData.family_id}`,
//             name: formData.consulting_type === "self" ? userData?.name : formData?.full_name,
//             email: formData.consulting_type === "self" ? userData?.email : formData?.email,
//             phone: formData.consulting_type === "self" ? userData?.phone : formData?.phone,
//             address: userData?.address,
//             dob: derivedDob,
//             // age: formData?.age,
//             ...(formData?.marital_status
//                 ? { marital_status: formData.marital_status }
//                 : {}),
//             gender: formData?.gender,
//             // marital_status: formData?.marital_status,
//             ...(formData?.marital_status
//                 ? { marital_status: formData.marital_status }
//                 : {}),
//             photo: userData?.photo,
//             doctor_id: formData.doctor_id,
//             slot_id: formData.slot_id,
//             date: formData.date,              // ✅ add
//             start_time: formData.start_time,  // ✅ add
//             end_time: formData.end_time,      // ✅ add
//             consultation_type: formData.consultation_type,
//         };

//         try {
//             const result = await createAppointment(appointmentData);
//             if (result?.success) {
//                 await trackCTA(
//                     "appointment-created",
//                     { id: Number(resolvedUserId), account_id: Number(resolvedAccountId) },
//                     "/consult/appointment"
//                 );
//                 alert("Appointment created successfully!");
//                 navigate("/home");
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Failed to create appointment");
//         }
//     };
//       const CAMPUS_IDS = [8, 22];
//     const isCampus = (doc) => CAMPUS_IDS.includes(Number(doc.id)); // id as number

//     const filteredDoctors = (() => {
//         let filtered = tabValue === 0
//             ? doctors?.filter(isCampus) // campus
//             : doctors?.filter((doc) => !isCampus(doc)); // online

//         // Apply category filter (supports multiple selections)
//         if (!selectedCategories.includes('All') && selectedCategories.length > 0 && filtered) {
//             filtered = filtered.filter((doc) => {
//                 // Check all possible specialty fields
//                 const specialtiesText = doc.specialties || doc.specialization || doc.specialty || '';

//                 if (!specialtiesText) return false;

//                 // Split into individual specialties
//                 const specialtyList = specialtiesText.split(',').map(s => s.trim().toLowerCase());

//                 // Check if ANY of the selected categories match ANY of the doctor's specialties
//                 return selectedCategories.some(selectedCategory => {
//                     const categoryLower = selectedCategory.toLowerCase();
//                     return specialtyList.some(specialty =>
//                         specialty === categoryLower ||
//                         specialty.includes(categoryLower) ||
//                         categoryLower.includes(specialty)
//                     );
//                 });
//             });
//         }

//         return filtered;
//     })();
//     // const filteredDoctors = (() => {
//     //     let filtered = tabValue === 0
//     //         ? doctors?.filter((doc) => doc.id === 8) // Campus
//     //         : doctors?.filter((doc) => doc.id !== 8); // Online

//     //     // Apply category filter (supports multiple selections)
//     //     if (!selectedCategories.includes('All') && selectedCategories.length > 0 && filtered) {
//     //         filtered = filtered.filter((doc) => {
//     //             // Check all possible specialty fields
//     //             const specialtiesText = doc.specialties || doc.specialization || doc.specialty || '';

//     //             if (!specialtiesText) return false;

//     //             // Split into individual specialties
//     //             const specialtyList = specialtiesText.split(',').map(s => s.trim().toLowerCase());

//     //             // Check if ANY of the selected categories match ANY of the doctor's specialties
//     //             return selectedCategories.some(selectedCategory => {
//     //                 const categoryLower = selectedCategory.toLowerCase();
//     //                 return specialtyList.some(specialty =>
//     //                     specialty === categoryLower ||
//     //                     specialty.includes(categoryLower) ||
//     //                     categoryLower.includes(specialty)
//     //                 );
//     //             });
//     //         });
//     //     }

//     //     return filtered;
//     // })();

//     // Count available doctors for each session type
//     const campusCount = doctors?.filter((doc) => doc.id === 8 && doc.next_available_slot)?.length || 0;
//     const onlineCount = doctors?.filter((doc) => doc.id !== 8 && doc.next_available_slot)?.length || 0;

//     const renderTherapistList = () => (
//         <Box sx={{ p: { xs: 2, sm: 4 }, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', minHeight: '100vh' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
//                 <Typography variant="h6" sx={{
//                     background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                     WebkitBackgroundClip: 'text',
//                     WebkitTextFillColor: 'transparent',
//                     fontWeight: 700,
//                 }}>
//                     Book Your Therapy Sessions
//                 </Typography>
//                 <IconButton
//                     onClick={() => navigate(-1)}
//                     sx={{
//                         backgroundColor: '#F0F5FF',
//                         width: 40,
//                         height: 40,
//                         borderRadius: '50%',
//                         color: '#0B2D6B',
//                         '&:hover': {
//                             backgroundColor: '#E0EBFF'
//                         }
//                     }}
//                 >
//                     <ArrowBackIcon />
//                 </IconButton>
//             </Box>

//             {/* Session Type Selection Cards */}
//             <Typography variant="subtitle2" sx={{ mb: 2, color: '#666', fontWeight: 500, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 1 }}>
//                 CHOOSE YOUR SESSION TYPE
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 4 }}>
//                 <Grid item xs={12} sm={6}>
//                     <Card
//                         onClick={() => setTabValue(0)}
//                         sx={{
//                             p: 3,
//                             borderRadius: 3,
//                             cursor: 'pointer',
//                             border: tabValue === 0 ? '2px solid #22c55e' : '1px solid #e0e0e0',
//                             background: tabValue === 0
//                                 ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)'
//                                 : 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
//                             transition: 'all 0.3s ease',
//                             '&:hover': {
//                                 transform: 'translateY(-4px)',
//                                 boxShadow: '0 8px 24px rgba(34, 197, 94, 0.15)',
//                             },
//                         }}
//                     >
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                 <BusinessIcon sx={{ fontSize: 32, color: tabValue === 0 ? '#22c55e' : '#666' }} />
//                                 <Box>
//                                     <Typography variant="h6" sx={{ fontWeight: 600, color: tabValue === 0 ? '#22c55e' : '#0B2D6B' }}>
//                                         Campus
//                                     </Typography>
//                                     <Typography variant="caption" sx={{ color: '#666' }}>
//                                         {campusCount} available
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             {tabValue === 0 && (
//                                 <CheckCircleIcon sx={{ color: '#22c55e', fontSize: 28 }} />
//                             )}
//                         </Box>
//                     </Card>
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                     <Card
//                         onClick={() => setTabValue(1)}
//                         sx={{
//                             p: 3,
//                             borderRadius: 3,
//                             cursor: 'pointer',
//                             border: tabValue === 1 ? '2px solid #14b8a6' : '1px solid #e0e0e0',
//                             background: tabValue === 1
//                                 ? 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)'
//                                 : 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
//                             transition: 'all 0.3s ease',
//                             '&:hover': {
//                                 transform: 'translateY(-4px)',
//                                 boxShadow: '0 8px 24px rgba(20, 184, 166, 0.15)',
//                             },
//                         }}
//                     >
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                 <VideocamIcon sx={{ fontSize: 32, color: tabValue === 1 ? '#14b8a6' : '#666' }} />
//                                 <Box>
//                                     <Typography variant="h6" sx={{ fontWeight: 600, color: tabValue === 1 ? '#14b8a6' : '#0B2D6B' }}>
//                                         Online
//                                     </Typography>
//                                     <Typography variant="caption" sx={{ color: '#666' }}>
//                                         {onlineCount} available
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             {tabValue === 1 && (
//                                 <CheckCircleIcon sx={{ color: '#14b8a6', fontSize: 28 }} />
//                             )}
//                         </Box>
//                     </Card>
//                 </Grid>
//             </Grid>

//             {/* Category Filter Chips */}
//             {/* <Box sx={{ mb: 3 }}>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
//                     {categories.map((category) => {
//                         const isSelected = selectedCategories.includes(category);
//                         const isAll = category === 'All';
                        
//                         return (
//                             <Chip
//                                 key={category}
//                                 label={category}
//                                 onClick={() => {
//                                     if (isAll) {
//                                         // If 'All' is clicked, select only 'All'
//                                         setSelectedCategories(['All']);
//                                     } else {
//                                         // If a specific category is clicked
//                                         if (isSelected) {
//                                             // Deselect this category
//                                             const newCategories = selectedCategories.filter(c => c !== category);
//                                             // If no categories left, select 'All'
//                                             setSelectedCategories(newCategories.length === 0 ? ['All'] : newCategories);
//                                         } else {
//                                             // Select this category and remove 'All'
//                                             const newCategories = selectedCategories.filter(c => c !== 'All');
//                                             setSelectedCategories([...newCategories, category]);
//                                         }
//                                     }
//                                 }}
//                                 sx={{
//                                     px: 1,
//                                     py: 2.5,
//                                     fontSize: '0.875rem',
//                                     fontWeight: 500,
//                                     borderRadius: 3,
//                                     cursor: 'pointer',
//                                     transition: 'all 0.2s ease',
//                                     border: isSelected ? '2px solid #8b5cf6' : '1px solid #e0e0e0',
//                                     backgroundColor: isSelected ? '#f3e8ff' : '#ffffff',
//                                     color: isSelected ? '#8b5cf6' : '#666',
//                                     '&:hover': {
//                                         backgroundColor: isSelected ? '#f3e8ff' : '#f5f5f5',
//                                         transform: 'translateY(-2px)',
//                                         boxShadow: '0 4px 12px rgba(139, 92, 246, 0.15)',
//                                     },
//                                 }}
//                             />
//                         );
//                     })}
//                 </Box>
//             </Box> */}

//             {/* Recent Visits Section */}
//             <Card sx={{ mb: 4, p: 3, borderRadius: 3, backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
//                     <Box sx={{
//                         width: 8,
//                         height: 8,
//                         borderRadius: '50%',
//                         background: 'linear-gradient(135deg, #22c55e, #14b8a6)'
//                     }} />
//                     <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600 }}>
//                         Recent Visits
//                     </Typography>
//                 </Box>
//                 <Stack spacing={2}>
//                     {recentVisits && recentVisits?.length > 0 ? (
//                         recentVisits.map((visit) => (
//                             <Box
//                                 key={visit.id}
//                                 sx={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     p: 2.5,
//                                     backgroundColor: '#f9fafb',
//                                     borderRadius: 3,
//                                     border: '1px solid #f0f0f0',
//                                     transition: 'all 0.2s ease',
//                                     '&:hover': {
//                                         backgroundColor: '#f5f5f5',
//                                         boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//                                     }
//                                 }}
//                             >
//                                 <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//                                     <PersonIcon sx={{ color: '#666' }} />
//                                     <Box>
//                                         <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
//                                             {visit?.dr_name}
//                                         </Typography>
//                                         <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
//                                             <Typography variant="caption" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                                 <CalendarTodayIcon sx={{ fontSize: 14 }} />
//                                                 {visit?.date
//                                                     ? new Date(visit.date).toLocaleDateString('en-GB', {
//                                                         day: 'numeric',
//                                                         month: 'short',
//                                                         year: 'numeric',
//                                                     })
//                                                     : ''}
//                                             </Typography>
//                                             <Typography variant="caption" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                                 <AccessTimeIcon sx={{ fontSize: 14 }} />
//                                                 {formatSlotToAMPM(visit?.time)}
//                                             </Typography>
//                                             <Chip
//                                                 label={visit.consultation_type.toLowerCase() === 'video'
//                                                     ? 'Video Consultation'
//                                                     : visit.consultation_type.toLowerCase() === 'audio'
//                                                         ? 'Phone Call'
//                                                         : visit.consultation_type}
//                                                 size="small"
//                                                 sx={{
//                                                     height: 20,
//                                                     fontSize: '0.7rem',
//                                                     backgroundColor: '#E3F2FD',
//                                                     color: '#1976D2'
//                                                 }}
//                                             />
//                                         </Box>
//                                     </Box>
//                                 </Box>
//                                 <Chip
//                                     label={visit.status.charAt(0).toUpperCase() + visit.status.slice(1).toLowerCase()}
//                                     size="small"
//                                     sx={{
//                                         backgroundColor: '#E8F5E9',
//                                         color: '#4CAF50',
//                                         fontWeight: 500
//                                     }}
//                                 />
//                             </Box>
//                         ))) : (
//                         <Typography variant="body1" sx={{ textAlign: 'center', mt: 4, color: '#777' }}>
//                             No recent visits available.
//                         </Typography>
//                     )}
//                 </Stack>
//             </Card>

//             <Box sx={{
//                 display: 'flex',
//                 flexDirection: { xs: 'column', md: 'row' },
//                 gap: { xs: 2, md: 4 },
//             }}>
//                 {/* Left Side - Therapist List */}
//                 <Box sx={{ flex: 1 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
//                         <Box sx={{
//                             width: 8,
//                             height: 8,
//                             borderRadius: '50%',
//                             background: 'linear-gradient(135deg, #22c55e, #14b8a6)'
//                         }} />
//                         <Typography
//                             variant="h6"
//                             sx={{
//                                 fontWeight: 600,
//                                 display: 'inline-block',
//                                 background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                 WebkitBackgroundClip: 'text',
//                                 WebkitTextFillColor: 'transparent',
//                             }}
//                         >
//                             Select Your Therapist
//                         </Typography>
//                     </Box>

//                     <Stack spacing={2}>
//                         {filteredDoctors && filteredDoctors.length > 0 ? (
//                             filteredDoctors?.map((doctor) => (
//                                 <Card
//                                     key={doctor.id}
//                                     sx={{
//                                         p: 3,
//                                         borderRadius: 4,
//                                         transition: 'all 0.3s ease',
//                                         border: '1px solid #f0f0f0',
//                                         background: '#ffffff',
//                                         boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
//                                         '&:hover': {
//                                             boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
//                                             transform: 'translateY(-4px)',
//                                             borderColor: '#e0e0e0',
//                                         },
//                                     }}
//                                 >
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                                         {/* Using DoctorAvatar component */}
//                                         <DoctorAvatar doctor={doctor} size={60} />

//                                         <Box sx={{ flex: 1 }}>
//                                             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
//                                                 <Box>
//                                                     <Typography variant="h6" sx={{ fontWeight: 600, color: '#0B2D6B', mb: 0.5 }}>
//                                                         {doctor?.name}
//                                                     </Typography>
//                                                     <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
//                                                         {doctor?.profession}
//                                                     </Typography>
//                                                 </Box>
//                                                 {/* <Button
//                                                     variant="outlined"
//                                                     size="small"
//                                                     onClick={() => handleViewProfile(doctor)}
//                                                     sx={{
//                                                         borderColor: '#4C41FF',
//                                                         color: '#4C41FF',
//                                                         textTransform: 'none',
//                                                         borderRadius: 2,
//                                                         '&:hover': {
//                                                             borderColor: '#3c32cc',
//                                                             backgroundColor: '#F8F7FF'
//                                                         }
//                                                     }}
//                                                 >
//                                                     View Profile
//                                                 </Button> */}
//                                             </Box>

//                                             {/* Specialization */}
//                                             {doctor?.specialization && (
//                                                 <Typography variant="body2" sx={{ color: '#555', mb: 0.5, lineHeight: 1.6, fontWeight: 500 }}>
//                                                     {doctor.specialization}
//                                                 </Typography>
//                                             )}

//                                             {/* Specialties */}
//                                             {doctor?.specialties && (
//                                                 <Typography variant="body2" sx={{ color: '#666', mb: 1, lineHeight: 1.6 }}>
//                                                     {doctor.specialties}
//                                                 </Typography>
//                                             )}

//                                             {/* Qualification */}
//                                             {doctor?.qualification && (
//                                                 <Typography variant="body2" sx={{ color: '#666', mb: 1.5, lineHeight: 1.6 }}>
//                                                     {doctor.qualification}
//                                                 </Typography>
//                                             )}

//                                             {/* {doctor?.rating && Number(doctor.rating) !== 0 && ( */}
//                                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                                                 <Rating
//                                                     value={Math.min(5, Number(doctor.rating))}
//                                                     precision={0.1}
//                                                     readOnly
//                                                     size="small"
//                                                     icon={<StarIcon fontSize="inherit" />}
//                                                     emptyIcon={<StarIcon fontSize="inherit" />}
//                                                 />

//                                                 <Typography variant="caption" sx={{ color: '#444' }}>
//                                                     {doctor.rating}/5
//                                                 </Typography>


//                                                 {/* <Box sx={{
//                                                     ml: 2,
//                                                     px: 1,
//                                                     py: 0.5,
//                                                     borderRadius: 1,
//                                                     bgcolor: doctor?.status === 'available' ? '#E8F5E8' : '#FFE8E8',
//                                                     color: doctor?.status === 'available' ? '#4CAF50' : '#F44336',
//                                                     fontSize: '0.75rem',
//                                                     fontWeight: 500
//                                                 }}>
//                                                     ● {doctor?.status === 'available' ? 'Online' : 'In Session'}
//                                                 </Box> */}
//                                             </Box>
//                                             {/* )} */}

//                                             <Box sx={{
//                                                 display: 'inline-flex',
//                                                 alignItems: 'center',
//                                                 gap: 0.5,
//                                                 px: 1.5,
//                                                 py: 0.5,
//                                                 borderRadius: 2,
//                                                 backgroundColor: doctor?.next_available_slot ? '#f0fdf4' : '#fef2f2',
//                                                 mb: 2
//                                             }}>
//                                                 <Box sx={{
//                                                     width: 6,
//                                                     height: 6,
//                                                     borderRadius: '50%',
//                                                     backgroundColor: doctor?.next_available_slot ? '#22c55e' : '#ef4444',
//                                                 }} />
//                                                 <Typography
//                                                     variant="caption"
//                                                     sx={{
//                                                         color: doctor?.next_available_slot ? '#166534' : '#991b1b',
//                                                         fontWeight: 500,
//                                                     }}
//                                                 >
//                                                     {doctor?.next_available_slot
//                                                         ? `Next: ${formatNextAvailability(doctor.next_available_slot)}`
//                                                         : 'Not available'}
//                                                 </Typography>
//                                             </Box>

//                                             {/* Action Buttons */}
//                                             <Box sx={{ display: 'flex', gap: 1.5 }}>
//                                                 <Button
//                                                     variant="outlined"
//                                                     size="small"
//                                                     onClick={() => handleViewProfile(doctor)}
//                                                     sx={{
//                                                         width: '140px', // 👈 set custom width
//                                                         borderColor: '#6366f1',
//                                                         borderWidth: '2px',
//                                                         color: '#6366f1',
//                                                         textTransform: 'none',
//                                                         borderRadius: 2,
//                                                         py: 0.6,
//                                                         px: 2,
//                                                         fontWeight: 600,
//                                                         fontSize: '0.875rem',
//                                                         '&:hover': {
//                                                             borderColor: '#4f46e5',
//                                                             borderWidth: '2px',
//                                                             backgroundColor: '#eef2ff',
//                                                             color: '#4f46e5',
//                                                         }
//                                                     }}
//                                                 >
//                                                     View Profile
//                                                 </Button>

//                                                 <Button
//                                                     variant="contained"
//                                                     size="small"
//                                                     onClick={() => handleBookAppointment(doctor)}
//                                                     disabled={!doctor?.next_available_slot}
//                                                     sx={{
//                                                         width: '180px', // 👈 set custom width
//                                                         background: doctor?.next_available_slot
//                                                             ? 'linear-gradient(90deg, #10b981 0%, #14b8a6 50%, #6366f1 100%)'
//                                                             : '#e0e0e0',
//                                                         textTransform: 'none',
//                                                         borderRadius: 2,
//                                                         py: 0.6,
//                                                         px: 2,
//                                                         fontWeight: 600,
//                                                         fontSize: '0.875rem',
//                                                         boxShadow: doctor?.next_available_slot
//                                                             ? '0 2px 8px rgba(16, 185, 129, 0.3)'
//                                                             : 'none',
//                                                         '&:hover': {
//                                                             background: doctor?.next_available_slot
//                                                                 ? 'linear-gradient(90deg, #059669 0%, #0d9488 50%, #4f46e5 100%)'
//                                                                 : '#e0e0e0',
//                                                             boxShadow: doctor?.next_available_slot
//                                                                 ? '0 4px 12px rgba(16, 185, 129, 0.4)'
//                                                                 : 'none',
//                                                         },
//                                                         '&.Mui-disabled': {
//                                                             backgroundColor: '#e0e0e0',
//                                                             color: '#999',
//                                                         },
//                                                     }}
//                                                 >
//                                                     Book Appointment
//                                                 </Button>
//                                             </Box>
//                                         </Box>
//                                     </Box>
//                                 </Card>
//                             ))) : (
//                             <Typography variant="body1" sx={{ textAlign: 'center', mt: 4, color: '#777' }}>
//                                 No doctors available.
//                             </Typography>
//                         )}
//                     </Stack>
//                 </Box>
//             </Box>

//             {/* Profile Modal */}
//             <Dialog
//                 open={profileModalOpen}
//                 onClose={handleCloseProfileModal}
//                 maxWidth="md"
//                 fullWidth
//             >
//                 <DialogTitle sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     borderBottom: '1px solid #e0e0e0'
//                 }}>
//                     <Typography variant="h6" sx={{
//                         fontWeight: 600, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                         WebkitBackgroundClip: 'text',
//                         WebkitTextFillColor: 'transparent',
//                     }}>
//                         Counsellor Profile
//                     </Typography>
//                     <IconButton onClick={handleCloseProfileModal}>
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent sx={{ p: 3 }}>
//                     {modalDoctor && (
//                         <Box>
//                             <Box sx={{ display: 'flex', alignItems: 'start', gap: 3, mb: 1 }}>
//                                 <Box sx={{ mt: 2 }}>
//                                     <DoctorAvatar doctor={modalDoctor} size={100} />
//                                 </Box>
//                                 <Box sx={{ flex: 1, mt: 2 }}>
//                                     <Typography variant="h5" sx={{ fontWeight: 600, color: '#0B2D6B', mb: 1 }}>
//                                         {modalDoctor?.name}
//                                     </Typography>
//                                     <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>
//                                         {modalDoctor?.profession}
//                                     </Typography>

//                                     <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
//                                         {modalDoctor?.specialization}
//                                     </Typography>

//                                     <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
//                                         {modalDoctor?.qualification}
//                                     </Typography>

//                                     {/* {modalDoctor?.rating && Number(modalDoctor.rating) !== 0 && ( */}
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
//                                         <Rating
//                                             value={modalDoctor?.rating}
//                                             precision={0.1}
//                                             readOnly
//                                             size="medium"
//                                         />
//                                         <Typography variant="body1" sx={{ color: '#444' }}>
//                                             {modalDoctor.rating}/5
//                                         </Typography>
//                                     </Box>
//                                     {/* )} */}

//                                 </Box>
//                             </Box>

//                             <Divider sx={{ mb: 2 }} />

//                             <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 1 }}>
//                                 About
//                             </Typography>
//                             <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.8, mb: 2 }}>
//                                 {modalDoctor?.description}
//                             </Typography>

//                             <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 1 }}>
//                                 Experience & Qualifications -
//                             </Typography>

//                             <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.8, mb: 2 }}>
//                                 {modalDoctor?.experience}
//                             </Typography>

//                             <Box sx={{ display: 'flex', gap: 2, mt: 3, justifyContent: "center" }}>
//                                 <Button
//                                     variant="contained"
//                                     disabled={!modalDoctor?.next_available_slot}
//                                     onClick={() => {
//                                         // 🔥 Track CTA event
//                                         const storedUser = localStorage.getItem('user');
//                                         const user = storedUser ? JSON.parse(storedUser) : null;

//                                         if (user && user.id) {
//                                             trackCTA('book_appointment', user, window.location.pathname);
//                                             console.log("✅ CTA tracked: book_appointment");
//                                         }

//                                         handleCloseProfileModal();
//                                         handleBookAppointment(modalDoctor);
//                                     }}
//                                     sx={{
//                                         minWidth: "auto",      // removes MUI default 64px width
//                                         background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                         textTransform: 'none',
//                                         py: 1.5,
//                                         borderRadius: 2,
//                                         '&:hover': {
//                                             backgroundColor: '#3c32cc'
//                                         },
//                                         '&.Mui-disabled': {
//                                             backgroundColor: '#ccc', // subtle gray for disabled state
//                                             color: '#666',
//                                         },
//                                     }}
//                                 >
//                                     Book Appointment
//                                 </Button>
//                             </Box>
//                         </Box>
//                     )}
//                 </DialogContent>
//             </Dialog>

//             {/* Booking Modal */}
//             <Dialog
//                 open={bookingModalOpen}
//                 onClose={handleCloseBookingModal}
//                 maxWidth="sm"
//                 fullWidth
//             >
//                 <DialogTitle sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     borderBottom: '1px solid #e0e0e0'
//                 }}>
//                     <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                         Book Appointment
//                     </Typography>
//                     <IconButton onClick={handleCloseBookingModal}>
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent sx={{ p: 3 }}>
//                     {modalDoctor && (
//                         <Box>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
//                                 <DoctorAvatar doctor={modalDoctor} size={60} />
//                                 <Box>
//                                     <Typography variant="h6" sx={{ fontWeight: 600, color: '#0B2D6B' }}>
//                                         {modalDoctor.name}
//                                     </Typography>
//                                     <Typography variant="body2" sx={{ color: '#666' }}>
//                                         {modalDoctor.profession || 'Lead Consultant Psychologist'}
//                                     </Typography>
//                                 </Box>
//                             </Box>

//                             <Typography variant="subtitle1" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 2 }}>
//                                 Select Session Type
//                             </Typography>

//                             <Grid container spacing={2} sx={{ mb: 3 }}>
//                                 <Grid item xs={6}>
//                                     <Card
//                                         sx={{
//                                             p: 2,
//                                             textAlign: 'center',
//                                             cursor: 'pointer',
//                                             border: selectedSessionType === 'video' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                             backgroundColor: selectedSessionType === 'video' ? '#F8F7FF' : 'white',
//                                             '&:hover': {
//                                                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                                             },
//                                             background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                                         }}
//                                         onClick={() => {
//                                             setSelectedSessionType('video');
//                                             setFormData(prev => ({ ...prev, consultation_type: 'video' }));
//                                         }}
//                                     >
//                                         <VideocamIcon sx={{ fontSize: 30, color: '#666', mb: 1 }} />
//                                         <Typography variant="body2" sx={{ fontWeight: 600 }}>
//                                             Video Call
//                                         </Typography>
//                                     </Card>
//                                 </Grid>

//                                 <Grid item xs={6}>
//                                     <Card
//                                         sx={{
//                                             p: 2,
//                                             textAlign: 'center',
//                                             cursor: 'pointer',
//                                             border: selectedSessionType === 'in_person' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                             backgroundColor: selectedSessionType === 'in_person' ? '#F8F7FF' : 'white',
//                                             '&:hover': {
//                                                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                                             }
//                                         }}
//                                         onClick={() => {
//                                             setSelectedSessionType('in_person');
//                                             setFormData(prev => ({ ...prev, consultation_type: 'in_person' }));
//                                         }}
//                                     >
//                                         <BusinessIcon sx={{ fontSize: 30, color: '#666', mb: 1 }} />
//                                         <Typography variant="body2" sx={{ fontWeight: 600 }}>
//                                             Phone Call
//                                         </Typography>
//                                     </Card>
//                                 </Grid>
//                             </Grid>

//                             <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
//                                 Next available slot: <strong></strong>
//                             </Typography>

//                             <Button
//                                 variant="contained"
//                                 fullWidth
//                                 disabled={!selectedSessionType}
//                                 onClick={() => {
//                                     handleCloseBookingModal();
//                                     setShowBookingForm(true);
//                                 }}
//                                 sx={{
//                                     height: 48,
//                                     backgroundColor: '#4C41FF',
//                                     borderRadius: 2,
//                                     textTransform: 'none',
//                                     fontSize: '1rem',
//                                     '&:hover': {
//                                         backgroundColor: '#3c32cc',
//                                     },
//                                     '&:disabled': {
//                                         backgroundColor: '#ccc'
//                                     }
//                                 }}
//                             >
//                                 Continue to Booking
//                             </Button>
//                         </Box>
//                     )}
//                 </DialogContent>
//             </Dialog>
//         </Box >
//     );

//     // Session Type Selection View (after therapist selection)
//     const renderSessionTypeSelection = () => (
//         <Box sx={{ p: { xs: 2, sm: 4 }, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
//                 <Typography variant="h6" sx={{
//                     fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                     WebkitBackgroundClip: 'text',
//                     WebkitTextFillColor: 'transparent',
//                 }}>
//                     Book Your Therapy Session
//                 </Typography>
//                 <IconButton
//                     onClick={handleBackToList}
//                     sx={{
//                         backgroundColor: '#F0F5FF',
//                         width: 40,
//                         height: 40,
//                         borderRadius: '50%',
//                         color: '#0B2D6B',
//                         '&:hover': {
//                             backgroundColor: '#E0EBFF'
//                         }
//                     }}
//                 >
//                     <ArrowBackIcon />
//                 </IconButton>
//             </Box>

//             <Box sx={{
//                 display: 'flex',
//                 flexDirection: { xs: 'column', md: 'row' },
//                 gap: { xs: 2, md: 4 },
//             }}>
//                 {/* Left Side - Therapist List (smaller) */}
//                 <Box sx={{ flex: 1 }}>
//                     <Typography variant="h6" sx={{ mb: 3, color: '#0B2D6B', fontWeight: 600 }}>
//                         Select Your Therapist
//                     </Typography>

//                     <Stack spacing={2}>
//                         {doctors.map((doctor) => (
//                             <Card
//                                 key={doctor.id}
//                                 sx={{
//                                     p: 2,
//                                     borderRadius: 3,
//                                     cursor: 'pointer',
//                                     transition: 'all 0.2s ease-in-out',
//                                     border: selectedDoctor?.id === doctor.id ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                     backgroundColor: selectedDoctor?.id === doctor.id ? '#F8F7FF' : 'white',
//                                     '&:hover': {
//                                         boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                                         transform: 'translateY(-1px)'
//                                     },
//                                     background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                                 }}
//                                 onClick={() => {
//                                     setSelectedDoctor(doctor);
//                                     setFormData(prev => ({
//                                         ...prev,
//                                         doctor_id: doctor.id,
//                                         dr_name: doctor.name || "",
//                                     }));
//                                     // Reset session type when switching doctors
//                                     setSelectedSessionType(null);
//                                 }}
//                             >
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                                     {/* Using DoctorAvatar component */}
//                                     <DoctorAvatar doctor={doctor} size={50} />

//                                     <Box sx={{ flex: 1 }}>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#0B2D6B' }}>
//                                             {doctor.name}
//                                         </Typography>
//                                         <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
//                                             {doctor?.profession}
//                                         </Typography>

//                                         {/* {doctor?.rating && Number(doctor.rating) !== 0 && ( */}
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             <Rating
//                                                 value={doctor?.rating}
//                                                 precision={0.1}
//                                                 readOnly
//                                                 size="small"
//                                             />
//                                             <Typography variant="caption" sx={{ color: '#444' }}>
//                                                 {doctor?.rating}/5
//                                             </Typography>
//                                         </Box>
//                                         {/* )} */}
//                                     </Box>
//                                 </Box>
//                             </Card>
//                         ))}
//                     </Stack>
//                 </Box>

//                 {/* Right Side - Doctor Profile & Session Selection */}
//                 <Box sx={{ flex: 1 }}>
//                     {selectedDoctor && (
//                         <>
//                             {/* Doctor Profile - FIXED WITH AVATAR */}
//                             <Box sx={{ mb: 4 }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
//                                     {/* Using DoctorAvatar component for profile */}
//                                     <DoctorAvatar doctor={selectedDoctor} size={80} />

//                                     <Box>
//                                         <Typography variant="h5" sx={{ fontWeight: 600, color: '#0B2D6B', mb: 1 }}>
//                                             {selectedDoctor?.name}
//                                         </Typography>
//                                         <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>
//                                             {selectedDoctor?.profession}
//                                         </Typography>

//                                         {/* <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
//                                             {selectedDoctor?.specialization}
//                                         </Typography>
//                                         <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
//                                             {selectedDoctor?.qualification}
//                                         </Typography> */}

//                                         {/* {selectedDoctor?.rating && Number(selectedDoctor.rating) !== 0 && ( */}
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             <Rating
//                                                 value={selectedDoctor?.rating}
//                                                 precision={0.1}
//                                                 readOnly
//                                                 size="small"
//                                             />
//                                             <Typography variant="body2" sx={{ color: '#444' }}>
//                                                 {selectedDoctor?.rating}/5
//                                             </Typography>
//                                         </Box>
//                                         {/* )} */}

//                                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
//                                             {(selectedDoctor?.specialties)?.split(',').map((specialty, index) => (
//                                                 <Chip
//                                                     key={index}
//                                                     label={specialty.trim()}
//                                                     size="small"
//                                                     sx={{
//                                                         backgroundColor: '#E3F2FD',
//                                                         color: '#1976D2',
//                                                         fontSize: '0.8rem'
//                                                     }}
//                                                 />
//                                             ))}
//                                         </Box>
//                                     </Box>
//                                 </Box>

//                                 {/* About Section */}
//                                 <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 2 }}>
//                                     About {selectedDoctor?.name}
//                                 </Typography>
//                                 <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.6, mb: 3 }}>
//                                     {selectedDoctor?.description} </Typography>
//                             </Box>

//                             {/* Session Type Selection */}
//                             <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 3 }}>
//                                 Select Session Type
//                             </Typography>

//                             {/* <Grid container spacing={2}>
//                                 <Grid item xs={12} sm={6}>
//                                     <Card
//                                         sx={{
//                                             p: 3,
//                                             textAlign: 'center',
//                                             cursor: 'pointer',
//                                             border: selectedSessionType === 'video' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                             background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                                             '&:hover': {
//                                                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                                             }
//                                         }}
//                                         onClick={() => {
//                                             setSelectedSessionType('video');
//                                             setFormData(prev => ({ ...prev, consultation_type: 'video' }));
//                                             setShowBookingForm(true);
//                                         }}
//                                     >
//                                         <VideocamIcon sx={{ fontSize: 40, color: '#666', mb: 1 }} />
//                                         <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
//                                             Video Call
//                                         </Typography>

//                                     </Card>
//                                 </Grid>

                               
//                                 <Grid item xs={12} sm={6}>
//                                     <Card
//                                         sx={{
//                                             p: 3,
//                                             textAlign: 'center',
//                                             cursor: userData?.enable_ivr === false ? 'not-allowed' : 'pointer',
//                                             height: 145,
//                                             overflow: 'hidden',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             border: selectedSessionType === 'phone' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                             background: userData?.enable_ivr === false
//                                                 ? '#f9f9f9'
//                                                 : 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                                             opacity: userData?.enable_ivr === false ? 0.7 : 1,
//                                             '&:hover': userData?.enable_ivr === false
//                                                 ? {}
//                                                 : { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
//                                         }}
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             if (userData?.enable_ivr === false) return;
//                                             setSelectedSessionType('phone');
//                                             setFormData(prev => ({ ...prev, consultation_type: 'audio' }));
//                                             setShowBookingForm(true);
//                                         }}
//                                     >
//                                         <PhoneCallback sx={{ fontSize: 40, color: userData?.enable_ivr === false ? '#aaa' : '#666', mb: userData?.enable_ivr === false ? 0.5 : 1 }} />
//                                         <Typography variant="h6" sx={{ fontWeight: 600, mb: userData?.enable_ivr === false ? 1 : 0 }}>
//                                             Phone Call
//                                         </Typography>

//                                         {userData?.enable_ivr === false && (
//                                             <Box
//                                                 sx={{
//                                                     px: 1.5,
//                                                     py: 0.8,
//                                                     borderRadius: 1.5,
//                                                     backgroundColor: '#FFF5F5',
//                                                     border: '1px solid #FFCDD2',
//                                                     display: 'flex',
//                                                     alignItems: 'flex-start',
//                                                     gap: 0.75,
//                                                     textAlign: 'left',
//                                                 }}
//                                             >
//                                                 <Box sx={{ color: '#E53935', fontSize: 14, mt: 0.15, flexShrink: 0 }}>ⓘ</Box>
//                                                 <Typography
//                                                     variant="caption"
//                                                     sx={{
//                                                         color: '#C62828',
//                                                         fontSize: '0.72rem',
//                                                         lineHeight: 1.4,
//                                                     }}
//                                                 >
//                                                     This feature is unavailable for your account. Please contact your HR for details.
//                                                 </Typography>
//                                             </Box>
//                                         )}
//                                     </Card>
//                                 </Grid>
//                             </Grid> */}
//                             <Grid container spacing={2} alignItems="stretch">
//                                 <Grid item xs={12} sm={6}>
//                                     <Card
//                                         sx={{
//                                             p: 3,
//                                             height: '100%',
//                                             minHeight: 180,
//                                             textAlign: 'center',
//                                             cursor: 'pointer',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             border: selectedSessionType === 'video' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                             background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                                             transition: 'all 0.2s',
//                                             '&:hover': {
//                                                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                                             }
//                                         }}
//                                         onClick={() => {
//                                             setSelectedSessionType('video');
//                                             setFormData(prev => ({ ...prev, consultation_type: 'video' }));
//                                             setShowBookingForm(true);
//                                         }}
//                                     >
//                                         <VideocamIcon sx={{ fontSize: 40, color: '#666', mb: 1.5 }} />
//                                         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                                             Video Call
//                                         </Typography>
//                                     </Card>
//                                 </Grid>

//                                 <Grid item xs={12} sm={6}>
//                                     <Card
//                                         sx={{
//                                             p: 3,
//                                             height: '100%',
//                                             minHeight: 180,
//                                             textAlign: 'center',
//                                             cursor: userData?.enable_ivr === false ? 'not-allowed' : 'pointer',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             gap: 1,
//                                             border: selectedSessionType === 'phone' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//                                             background: userData?.enable_ivr === false
//                                                 ? '#f9f9f9'
//                                                 : 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                                             opacity: userData?.enable_ivr === false ? 0.85 : 1,
//                                             transition: 'all 0.2s',
//                                             '&:hover': userData?.enable_ivr === false
//                                                 ? {}
//                                                 : { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
//                                         }}
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             if (userData?.enable_ivr === false) return;
//                                             setSelectedSessionType('phone');
//                                             setFormData(prev => ({ ...prev, consultation_type: 'audio' }));
//                                             setShowBookingForm(true);
//                                         }}
//                                     >
//                                         <PhoneCallback sx={{ fontSize: 40, color: userData?.enable_ivr === false ? '#aaa' : '#666' }} />
//                                         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                                             Phone Call
//                                         </Typography>

//                                         {userData?.enable_ivr === false && (
//                                             <Box
//                                                 sx={{
//                                                     mt: 0.5,
//                                                     px: 1.5,
//                                                     py: 1,
//                                                     borderRadius: 1.5,
//                                                     backgroundColor: '#FFF5F5',
//                                                     border: '1px solid #FFCDD2',
//                                                     display: 'flex',
//                                                     alignItems: 'flex-start',
//                                                     gap: 0.75,
//                                                     textAlign: 'left',
//                                                     width: '100%',
//                                                 }}
//                                             >
//                                                 <Box sx={{ color: '#E53935', fontSize: 14, mt: 0.15, flexShrink: 0 }}>ⓘ</Box>
//                                                 <Typography
//                                                     variant="caption"
//                                                     sx={{
//                                                         color: '#C62828',
//                                                         fontSize: '0.72rem',
//                                                         lineHeight: 1.4,
//                                                     }}
//                                                 >
//                                                     This feature is unavailable for your account. Please contact your HR for details.
//                                                 </Typography>
//                                             </Box>
//                                         )}
//                                     </Card>
//                                 </Grid>
//                             </Grid>

//                         </>
//                     )}
//                 </Box>
//             </Box>
//         </Box>
//     );

//     // Original Booking Form (when showBookingForm is true and selectedSessionType is set)
//     const renderBookingForm = () => (
//         <Box sx={{ background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
//             <Box sx={{ p: { xs: 2, sm: 4 } }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
//                     <Typography variant="h6" sx={{
//                         fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                         WebkitBackgroundClip: 'text',
//                         WebkitTextFillColor: 'transparent',
//                     }}>
//                         Book Your Sessions
//                     </Typography>
//                     <IconButton
//                         onClick={() => setShowBookingForm(false)}
//                         sx={{
//                             backgroundColor: '#F0F5FF',
//                             width: 40,
//                             height: 40,
//                             borderRadius: '50%',
//                             color: '#0B2D6B',
//                             '&:hover': {
//                                 backgroundColor: '#E0EBFF'
//                             }
//                         }}
//                     >
//                         <ArrowBackIcon />
//                     </IconButton>
//                 </Box>

//                 <Box sx={{
//                     display: 'flex',
//                     flexDirection: { xs: 'column', md: 'row' },
//                     gap: { xs: 2, md: 4 },

//                 }}>
//                     {/* Left Card - Date & Time Selection */}
//                     <Card sx={{ flex: 1, borderRadius: 3, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
//                         <CardContent>
//                             {/* Date Picker */}
//                             <Typography
//                                 variant="subtitle1"
//                                 sx={{ color: "#103680", fontSize: '14px', fontWeight: 500, mt: 3 }}
//                             >
//                                 Select Date
//                             </Typography>

//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1, justifyContent: "space-between" }}>
//                                 <IconButton
//                                     onClick={goToPrevMonth}
//                                     disabled={currentYear === today.getFullYear() && currentMonth === today.getMonth()}
//                                     sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
//                                 >
//                                     <ArrowBackIosNewIcon fontSize="small" />
//                                 </IconButton>

//                                 <Typography sx={{ fontSize: '16px', fontWeight: 600, minWidth: 120, textAlign: "center" }}>
//                                     {new Date(currentYear, currentMonth).toLocaleString("default", {
//                                         month: "long",
//                                         year: "numeric",
//                                     })}
//                                 </Typography>

//                                 <IconButton
//                                     onClick={goToNextMonth}
//                                     sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
//                                 >
//                                     <ArrowForwardIosIcon fontSize="small" />
//                                 </IconButton>
//                             </Box>

//                             <Box sx={{ p: 1 }}>
//                                 <Box
//                                     sx={{
//                                         display: "grid",
//                                         gridTemplateColumns: { xs: "repeat(4, 1fr)", md: "repeat(7, 1fr)" },
//                                         gap: { xs: 0.5, md: 2 },
//                                         p: 1,
//                                     }}
//                                 >
//                                     {/* Weekday headers */}
//                                     {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, i) => (
//                                         <Typography
//                                             key={day}
//                                             variant="body2"
//                                             sx={{
//                                                 textAlign: "center",
//                                                 color: "#000",
//                                                 fontWeight: 500,
//                                                 display: { xs: i < 4 ? "block" : "none", md: "block" },
//                                             }}
//                                         >
//                                             {day}
//                                         </Typography>
//                                     ))}

//                                     {/* Empty slots before month starts */}
//                                     {[...Array(firstDayOfMonth)].map((_, idx) => (
//                                         <Box key={`empty-${idx}`} />
//                                     ))}

//                                     {/* Days */}
//                                     {days.map((day) => {
//                                         const fullDate = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
//                                         const isAvailable = availableDates.includes(fullDate);

//                                         return (
//                                             <Box
//                                                 key={day}
//                                                 sx={{
//                                                     display: "flex",
//                                                     justifyContent: "center",
//                                                     alignItems: "center",
//                                                 }}
//                                             >
//                                                 <Button
//                                                     disabled={!isAvailable}
//                                                     onClick={() => {
//                                                         setSelectedDate(fullDate); // store full date
//                                                         setFormData(prev => ({
//                                                             ...prev,
//                                                             date: fullDate,
//                                                         }));

//                                                         // ✅ Log slots for this date
//                                                         const dateKey = Object.keys(slotsByDate).find(d => d.startsWith(fullDate));
//                                                         const slots = dateKey ? slotsByDate[dateKey] : [];

//                                                         // const formattedSlots = slots.map(slot =>
//                                                         //     `${formatTime(slot.start_time)} to ${formatTime(slot.end_time)}`
//                                                         // );
//                                                         // setSlotsForSelectedDate(formattedSlots);
//                                                         setSlotsForSelectedDate(slots);

//                                                     }}
//                                                     sx={{
//                                                         width: "70%",
//                                                         aspectRatio: "1 / 1",
//                                                         borderRadius: 5,
//                                                         backgroundColor: selectedDate === fullDate
//                                                             ? "#4C41FF"
//                                                             : isAvailable
//                                                                 ? "#FBFBFB"
//                                                                 : "#e0e0e0",
//                                                         color: selectedDate === fullDate
//                                                             ? "#fff"
//                                                             : isAvailable
//                                                                 ? "#4C41FF"
//                                                                 : "#aaa",
//                                                         fontWeight: selectedDate === fullDate ? 600 : 400,
//                                                         fontSize: "14px",
//                                                         textTransform: "none",
//                                                         "&:hover": {
//                                                             backgroundColor: isAvailable
//                                                                 ? selectedDate === fullDate
//                                                                     ? "#3c32cc"
//                                                                     : "#f5f5f5"
//                                                                 : "#e0e0e0",
//                                                         },
//                                                     }}
//                                                 >
//                                                     {day}
//                                                 </Button>
//                                             </Box>
//                                         );
//                                     })}

//                                 </Box>
//                             </Box>

//                             {/* Time Slots */}
//                             <Box>
//                                 <Typography
//                                     variant="subtitle1"
//                                     sx={{ mb: 2, color: '#103680', fontWeight: 550, mt: 4 }}
//                                 >
//                                     Available Slot
//                                 </Typography>

//                                 {/* Render available slots for selected date */}
//                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                                     {slotsForSelectedDate.length === 0 ? (
//                                         <Typography variant="body2" sx={{ color: '#888' }}>
//                                             {/* No slots available */}
//                                             {!selectedDate
//                                                 ? "Please select a date to view available slots"
//                                                 : "No slots available for the selected date"}
//                                         </Typography>
//                                     ) : (
//                                         slotsForSelectedDate.map((slot, idx) => (
//                                             <Button
//                                                 key={idx}
//                                                 variant={selectedSlot === slot ? 'contained' : 'outlined'}
//                                                 color="primary"
//                                                 size="small"
//                                                 disabled={isSlotDisabled(slot)}
//                                                 onClick={() => {
//                                                     setSelectedSlot(slot);
//                                                     setFormData(prev => ({
//                                                         ...prev,
//                                                         start_time: slot.start_time,
//                                                         end_time: slot.end_time,
//                                                         slot_id: slot.id,
//                                                     }));
//                                                 }}
//                                                 sx={{
//                                                     textTransform: 'none',
//                                                     borderRadius: 2,
//                                                     minWidth: '100px',
//                                                 }}
//                                             >
//                                                 {`${slot.start_time.slice(0, 5)} - ${slot.end_time.slice(0, 5)}`}
//                                             </Button>
//                                         ))
//                                     )}
//                                 </Box>

//                             </Box>

//                         </CardContent>
//                     </Card>

//                     {/* Right Card - Patient Information */}
//                     <Card sx={{ flex: 1, borderRadius: 3, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
//                         <CardContent>
//                             <Card
//                                 elevation={3}
//                                 sx={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: 3,
//                                     p: 2,
//                                     mb: 3,
//                                     borderRadius: 3,
//                                     background: 'linear-gradient(135deg, #F0F5FF 0%, #ffffff 100%)',
//                                     boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
//                                 }}
//                             >
//                                 <DoctorAvatar doctor={selectedDoctor} size={80} borderRadius={2} />

//                                 {selectedDoctor && (
//                                     <Box sx={{ mt: 2 }}>
//                                         <Typography variant="h6" sx={{ fontWeight: 600, color: '#103680' }}>
//                                             {selectedDoctor.name}
//                                         </Typography>

//                                         <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
//                                             {selectedDoctor.profession || 'Psychotherapist & Hypnotherapist'}
//                                         </Typography>

//                                         {/* {selectedDoctor?.rating && Number(selectedDoctor.rating) !== 0 && ( */}
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                                             <Rating
//                                                 value={selectedDoctor.rating ?? 0}
//                                                 precision={0.1}
//                                                 readOnly
//                                                 size="small"
//                                                 icon={<StarIcon fontSize="inherit" />}
//                                                 emptyIcon={<StarIcon fontSize="inherit" />}
//                                             />
//                                             <Typography variant="caption" sx={{ color: '#444' }}>
//                                                 {selectedDoctor.rating ?? 0}/5
//                                             </Typography>
//                                         </Box>
//                                         {/* )} */}

//                                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
//                                             {selectedDoctor.specialties?.split(',').map((specialty, index) => (
//                                                 <Chip
//                                                     key={index}
//                                                     label={specialty.trim()}
//                                                     size="small"
//                                                     sx={{
//                                                         backgroundColor: '#E3F2FD',
//                                                         color: '#1976D2',
//                                                         fontSize: '0.7rem',
//                                                         height: 20
//                                                     }}
//                                                 />
//                                             ))}
//                                         </Box>
//                                     </Box>
//                                 )}
//                             </Card>
//                             <Box
//                                 sx={{
//                                     display: 'grid',
//                                     gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
//                                     gap: 2,
//                                     mt: 1,
//                                 }}
//                             >
//                                 <Box>
//                                     <Typography variant="subtitle1" sx={{ mb: 1, color: '#103680', fontWeight: 550 }}>
//                                         Consultation Type
//                                     </Typography>
//                                     <FormControl fullWidth>
//                                         <Select
//                                             name="consultation_type"
//                                             displayEmpty
//                                             value={formData.consultation_type}
//                                             onChange={(e) => setFormData({ ...formData, consultation_type: e.target.value })}
//                                             sx={{ height: 45, borderRadius: 2 }}
//                                         >
//                                             <MenuItem value="audio">Phone Call</MenuItem>
//                                             <MenuItem value="video">Video Call</MenuItem>
//                                         </Select>
//                                     </FormControl>
//                                 </Box>

//                                 <Box>
//                                     <Typography variant="subtitle1" sx={{ mb: 1, color: "#103680", fontWeight: 550 }}>
//                                         Consulting for
//                                     </Typography>

//                                     <FormControl fullWidth>
//                                         <Select
//                                             name="consulting_type"
//                                             displayEmpty
//                                             value={formData.consulting_type}
//                                             onChange={(e) => {
//                                                 const selectedName = e.target.value;

//                                                 if (selectedName === "self" && userData) {
//                                                     // If "Self" is selected, populate formData with current user data
//                                                     setFormData((prev) => ({
//                                                         ...prev,
//                                                         consulting_type: "self",
//                                                         gender: userData.gender ? userData.gender.charAt(0).toUpperCase() + userData.gender.slice(1).toLowerCase() : "",
//                                                         marital_status: userData.marital_status || "",
//                                                         age: userData.age || "",
//                                                         email: userData.email || "",
//                                                         phone: userData.phone || "",
//                                                         name: userData.name || "",
//                                                     }));
//                                                 } else {
//                                                     // Populate formData with selected family member data
//                                                     const selectedMember = familyData.find((m) => m.name === selectedName);
//                                                     setFormData((prev) => ({
//                                                         ...prev,
//                                                         consulting_type: selectedName,
//                                                         gender: selectedMember?.gender ? selectedMember.gender.charAt(0).toUpperCase() + selectedMember.gender.slice(1).toLowerCase() : "",
//                                                         marital_status: selectedMember?.relationship || "",
//                                                         age: selectedMember?.age || "",
//                                                         email: selectedMember?.email || "",
//                                                         phone: selectedMember?.contact || "",
//                                                         full_name: selectedMember?.name || "",
//                                                         family_id: selectedMember?.id,
//                                                     }));
//                                                 }
//                                             }}
//                                             sx={{ height: 45, borderRadius: 2 }}
//                                         >
//                                             <MenuItem value="self">Self</MenuItem>
//                                             {familyData.length > 0 &&
//                                                 familyData.map((member) => (
//                                                     <MenuItem key={member.id} value={member.name}>
//                                                         {member.name} ({member.relationship})
//                                                     </MenuItem>
//                                                 ))}
//                                         </Select>
//                                     </FormControl>

//                                 </Box>
//                             </Box>
//                             {formData.consultation_type === 'audio' && (() => {
//                                 const isSelf = formData.consulting_type === 'self';
//                                 const phone = isSelf ? userData?.phone : formData.phone;
//                                 const hasPhone = phone && phone.trim() !== '';
//                                 if (hasPhone) return null;
//                                 return (
//                                     <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }}>
//                                         {isSelf
//                                             ? 'A phone number is required for Phone Call consultations. '
//                                             : 'A phone number is required for Phone Call consultations. '}
//                                         <span
//                                             onClick={() => navigate(isSelf ? '/profile' : '/family')}
//                                             style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline' }}
//                                         >
//                                             {isSelf ? 'Update your profile' : 'Update family member profile'}
//                                         </span>
//                                         {' to add a valid phone number before proceeding.'}
//                                     </Alert>
//                                 );
//                             })()}
//                             <Typography
//                                 variant="subtitle1"
//                                 sx={{ mt: 7, mb: 2, color: "#103680", fontSize: "18px", fontWeight: 500 }}
//                             >
//                                 Patient Information
//                             </Typography>

//                             <Paper
//                                 elevation={3}
//                                 sx={{
//                                     p: 4,
//                                     borderRadius: 3,
//                                     bgcolor: 'grey.50',
//                                     maxWidth: 600,
//                                     mx: 'auto',
//                                 }}
//                             >
//                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
//                                     {[
//                                         { label: 'Full Name', value: formData.name },
//                                         { label: 'Age', value: formData.age },
//                                         { label: 'Gender', value: formData.gender },
//                                         {
//                                             label: 'Marital Status',
//                                             value: formData.marital_status
//                                                 ? formData.marital_status.charAt(0).toUpperCase() +
//                                                 formData.marital_status.slice(1)
//                                                 : '-',
//                                         },
//                                     ].map((item) => (
//                                         <Box
//                                             key={item.label}
//                                             sx={{
//                                                 flex: '1 1 48%',
//                                                 p: 1.5,
//                                                 borderRadius: 2,
//                                                 bgcolor: 'white',
//                                                 boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
//                                             }}
//                                         >
//                                             <Typography
//                                                 variant="subtitle2"
//                                                 sx={{
//                                                     color: '#666',
//                                                     fontWeight: 500,
//                                                     mb: 0.5,
//                                                 }}
//                                             >
//                                                 {item.label}
//                                             </Typography>

//                                             <Typography
//                                                 variant="body1"
//                                                 sx={{
//                                                     color: '#333',
//                                                     fontWeight: 400,
//                                                 }}
//                                             >
//                                                 {item.value || '-'}
//                                             </Typography>
//                                         </Box>
//                                     ))}
//                                 </Box>
//                             </Paper>

//                             <FormControlLabel
//                                 control={
//                                     <Checkbox
//                                         disableRipple
//                                         checked={accepted}
//                                         onChange={(e) => {
//                                             setOpenModal(true); // 👈 Open modal whenever checkbox is clicked
//                                         }}
//                                         icon={
//                                             <Box
//                                                 sx={{
//                                                     width: 20,
//                                                     height: 20,
//                                                     border: "1px solid rgba(0,0,0,0.6)",
//                                                     borderRadius: "4px",
//                                                 }}
//                                             />
//                                         }
//                                         checkedIcon={
//                                             <Box
//                                                 sx={{
//                                                     width: 20,
//                                                     height: 20,
//                                                     backgroundColor: "#F5F5F5",
//                                                     borderRadius: "4px",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                 }}
//                                             >
//                                                 <CheckIcon sx={{ fontSize: 18, color: "#000" }} />
//                                             </Box>
//                                         }
//                                     />
//                                 }
//                                 label={
//                                     <span>
//                                         I accept the{" "}
//                                         <Box
//                                             component="span"
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 setOpenModal(true);
//                                             }}
//                                             sx={{
//                                                 cursor: "pointer",
//                                                 textDecoration: "underline",
//                                                 color: "primary.main",
//                                                 "&:hover": { textDecoration: "none" },
//                                             }}
//                                         >
//                                             Terms & Conditions and Privacy Policy
//                                         </Box>
//                                     </span>

//                                 }
//                                 sx={{ mt: 3 }}
//                             />

//                             <Box sx={{ display: "flex", justifyContent: "center" }}>
//                                 <Button
//                                     variant="contained"
//                                     sx={{
//                                         height: 50,
//                                         mt: 2,
//                                         background:
//                                             accepted && selectedDate && selectedSlot
//                                                 ? 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
//                                                 : '#ccc',
//                                         borderRadius: 2,
//                                         textTransform: 'none',
//                                         minWidth: 'auto',

//                                         '&:hover': {
//                                             background:
//                                                 accepted && selectedDate && selectedSlot
//                                                     ? 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
//                                                     : '#ccc',
//                                         },

//                                         '&:disabled': {
//                                             background: '#ccc',
//                                             color: '#888',
//                                         },
//                                     }}
//                                     disabled={!accepted || !selectedDate || !selectedSlot || (formData.consultation_type === 'audio' && (() => { const p = formData.consulting_type === 'self' ? userData?.phone : formData.phone; return !p || p.trim() === ''; })())}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </Button>
//                             </Box>
//                         </CardContent>
//                     </Card>
//                 </Box>

//                 <Snackbar
//                     open={snackbar.open}
//                     autoHideDuration={2000}
//                     onClose={handleClose}
//                     anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//                 >
//                     <Card sx={{ width: 300, height: 100, backgroundColor: '#fefefe', boxShadow: 3, p: 2 }}>
//                         <Alert
//                             onClose={handleClose}
//                             severity={snackbar.severity}
//                             sx={{ width: '100%' }}
//                         >
//                             <Typography variant="body1">
//                                 {snackbar.message}
//                             </Typography>
//                         </Alert>
//                     </Card>
//                 </Snackbar>

//                 <Modal open={openModal} onClose={() => setOpenModal(false)}>
//                     <Box
//                         sx={{
//                             height: "100vh",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         <Paper
//                             sx={{
//                                 p: 3,
//                                 maxWidth: 800,
//                                 width: "90%",
//                                 maxHeight: "80vh",
//                                 borderRadius: 2,
//                                 outline: "none",
//                                 position: "relative", // ✅ For close icon positioning
//                                 display: "flex",
//                                 flexDirection: "column",
//                             }}
//                         >
//                             {/* ✅ Close Icon */}
//                             <IconButton
//                                 onClick={() => setOpenModal(false)}
//                                 sx={{
//                                     position: "absolute",
//                                     top: 12,
//                                     right: 12,
//                                     color: "#555",
//                                     "&:hover": { backgroundColor: "transparent", color: "#000" },
//                                 }}
//                             >
//                                 <CloseIcon />
//                             </IconButton>

//                             <Typography variant="h6" sx={{ mb: 2, pr: 4 }}>
//                                 Terms & Conditions
//                             </Typography>
//                             <Divider sx={{ mb: 2 }} />

//                             <Typography
//                                 sx={{
//                                     mb: 2,
//                                     flex: 1,
//                                     overflowY: "auto",
//                                     fontSize: 14,
//                                     color: "#444",
//                                 }}
//                             >
//                                 {/* Point 1 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>1. Confidentiality & Privacy Protection:</strong> I understand that all personal information and session content will be kept strictly confidential, stored securely with end-to-end encryption, and will not be shared without my written consent except when legally mandated (risk of harm, court orders, child protection).
//                                 </Box>

//                                 {/* Point 2 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>2. Nature & Limitations of Online Services:</strong> I acknowledge the limitations of online therapy including potential technical issues, reduced non-verbal observation, and that it may not be suitable for severe psychiatric conditions. I agree to maintain a private environment during sessions.
//                                 </Box>

//                                 {/* Point 3 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>3. Voluntary Participation:</strong> I am seeking these services voluntarily and understand I can pause or discontinue at any time without penalty. I can decline to answer questions or discuss topics.
//                                 </Box>

//                                 {/* Point 4 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>4. Services Scope & Outcomes:</strong> The sessions may include psychological assessments, sound therapy, emotional support, behavioral guidance, wellness coaching, or clinical counselling. I understand that the expected outcome of therapy is not cure but is meant for care and support.
//                                 </Box>

//                                 {/* Point 5 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>5. NOT a Crisis or Emergency Service:</strong> I understand this is NOT a crisis service. In emergencies, I will contact 112, visit the nearest hospital, call crisis helplines (NIMHANS: 080-46110007, Vandrevala: 1860-2662-345, iCall: 9152987821), or contact the emergency number provided on the app.
//                                 </Box>

//                                 {/* Point 6 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>6. Record-Keeping & Data Storage:</strong> I consent to secure digital storage of clinical records for continuity of care, compliant with IT Act 2000. Records will be retained for 7 years. I have the right to access my records.
//                                 </Box>

//                                 {/* Point 7 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>7. Technical Requirements:</strong> I confirm I have stable internet, compatible device, updated echoBuddy app, and a private space. I am responsible for my technical setup.
//                                 </Box>

//                                 {/* Point 8 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>8. Professional Boundaries:</strong> I understand that the relationship with my counsellor is strictly professional and therapeutic in nature. Contact will be limited to scheduled sessions and communication through the echoBuddy platform.
//                                 </Box>

//                                 {/* Point 9 */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #ccc",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f9f9f9",
//                                     }}
//                                 >
//                                     <strong>9. Consent Validity:</strong> This consent is valid for all my appointments and counselling sessions through echoBuddy. I understand I can withdraw this consent at any time by providing written notice through the app or email. The consent will remain in effect until I choose to withdraw it.
//                                 </Box>

//                                 {/* Declaration */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         mb: 2,
//                                         border: "1px solid #bbb",
//                                         borderRadius: 2,
//                                         backgroundColor: "#f1f1f1",
//                                     }}
//                                 >
//                                     <strong>Declaration & Consent:</strong>
//                                     <br /><br />

//                                     {/* ✅ Each point with circular icon */}
//                                     <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                                         <Box
//                                             sx={{
//                                                 width: 28,
//                                                 height: 28,
//                                                 borderRadius: "50%",
//                                                 backgroundColor: "#e3f2fd", // light blue background
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 mr: 1.5,
//                                             }}
//                                         >
//                                             <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} /> {/* Blue icon */}
//                                         </Box>
//                                         I have read and understood all terms and conditions above.
//                                     </Box>

//                                     <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                                         <Box
//                                             sx={{
//                                                 width: 28,
//                                                 height: 28,
//                                                 borderRadius: "50%",
//                                                 backgroundColor: "#e3f2fd",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 mr: 1.5,
//                                             }}
//                                         >
//                                             <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                                         </Box>
//                                         I am voluntarily consenting to receive psychological counselling services.
//                                     </Box>

//                                     <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                                         <Box
//                                             sx={{
//                                                 width: 28,
//                                                 height: 28,
//                                                 borderRadius: "50%",
//                                                 backgroundColor: "#e3f2fd",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 mr: 1.5,
//                                             }}
//                                         >
//                                             <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                                         </Box>
//                                         I understand the nature, benefits, risks, and limitations of online therapy.
//                                     </Box>

//                                     <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                                         <Box
//                                             sx={{
//                                                 width: 28,
//                                                 height: 28,
//                                                 borderRadius: "50%",
//                                                 backgroundColor: "#e3f2fd",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 mr: 1.5,
//                                             }}
//                                         >
//                                             <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                                         </Box>
//                                         I understand that the expected outcome of therapy is not cure but is meant for care and support.
//                                     </Box>

//                                     <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                                         <Box
//                                             sx={{
//                                                 width: 28,
//                                                 height: 28,
//                                                 borderRadius: "50%",
//                                                 backgroundColor: "#e3f2fd",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 mr: 1.5,
//                                             }}
//                                         >
//                                             <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                                         </Box>
//                                         I understand this is not an emergency service.
//                                     </Box>

//                                     <Box sx={{ display: "flex", alignItems: "center" }}>
//                                         <Box
//                                             sx={{
//                                                 width: 28,
//                                                 height: 28,
//                                                 borderRadius: "50%",
//                                                 backgroundColor: "#e3f2fd",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 mr: 1.5,
//                                             }}
//                                         >
//                                             <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
//                                         </Box>
//                                         I understand this consent applies to all my appointments with echoBuddy.
//                                     </Box>
//                                 </Box>

//                                 {/* I AGREE section */}
//                                 <Box
//                                     sx={{
//                                         p: 2,
//                                         pt: 1,
//                                         border: "1px solid #aaa",
//                                         borderRadius: 2,
//                                         backgroundColor: "#e9f5ff",
//                                     }}
//                                 >
//                                     <Box
//                                         sx={{
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             my: 1
//                                         }}
//                                     >
//                                         <Button
//                                             variant="contained"
//                                             color="primary"
//                                             onClick={() => {
//                                                 setAccepted(true);
//                                                 setOpenModal(false);
//                                             }}
//                                             sx={{
//                                                 textTransform: "none",
//                                                 px: 1.5,          // smaller horizontal padding
//                                                 py: 0.5,          // smaller vertical padding
//                                                 fontSize: 12,     // smaller text
//                                                 fontWeight: 500,
//                                                 borderRadius: 1.5,
//                                                 minWidth: 70,     // smaller width
//                                                 height: 30,       // set explicit height
//                                             }}
//                                         >
//                                             I AGREE
//                                         </Button>
//                                     </Box>

//                                     By reading this form, I provide my informed consent to receive psychological counselling services through echoBuddy for all my appointments, and I confirm that I have read and agree to all the terms and conditions mentioned above. This consent remains valid for all future sessions unless I withdraw it in writing.
//                                 </Box>
//                             </Typography>
//                         </Paper>
//                     </Box>
//                 </Modal>
//             </Box>
//         </Box>
//     );

//     // Chat Dialog Component
//     const renderChatDialog = () => (
//         <Dialog
//             open={chatOpen}
//             onClose={handleCloseChat}
//             maxWidth="sm"
//             fullWidth
//             PaperProps={{
//                 sx: {
//                     borderRadius: '20px',
//                     overflow: 'hidden',
//                     height: '600px',
//                     display: 'flex',
//                     flexDirection: 'column',
//                 },
//             }}
//         >
//             {/* Chat Header */}
//             <Box
//                 sx={{
//                     padding: '14px 22px',
//                     background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                     color: '#fff',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                 }}
//             >
//                 <Box
//                     sx={{
//                         width: 38,
//                         height: 38,
//                         background: 'rgba(255,255,255,0.2)',
//                         borderRadius: '10px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: 18,
//                     }}
//                 >
//                     👩‍⚕️
//                 </Box>
//                 <Box sx={{ flex: 1 }}>
//                     <Typography
//                         sx={{
//                             fontFamily: "'Outfit', sans-serif",
//                             fontSize: 16,
//                             fontWeight: 700,
//                         }}
//                     >
//                         {chatDoctor?.name || 'Counsellor'}
//                     </Typography>
//                     <Typography sx={{ fontSize: 11, opacity: 0.85 }}>
//                         <Box
//                             component="span"
//                             sx={{
//                                 width: 7,
//                                 height: 7,
//                                 background: '#4ADE80',
//                                 borderRadius: '50%',
//                                 display: 'inline-block',
//                                 mr: 0.5,
//                             }}
//                         />
//                         Live chat · Confidential & safe
//                     </Typography>
//                 </Box>
//                 <IconButton onClick={handleCloseChat} sx={{ color: '#fff' }}>
//                     <CloseIcon />
//                 </IconButton>
//             </Box>

//             {/* Chat Messages */}
//             <Box
//                 sx={{
//                     flex: 1,
//                     overflowY: 'auto',
//                     padding: '18px 22px',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     gap: '12px',
//                     background: '#FAFCFB',
//                 }}
//             >
//                 {chatMessages.map((msg, idx) => (
//                     <Box
//                         key={idx}
//                         sx={{
//                             maxWidth: '80%',
//                             padding: '11px 15px',
//                             fontSize: 13,
//                             lineHeight: 1.5,
//                             animation: 'chatFadeIn 0.3s ease-out',
//                             '@keyframes chatFadeIn': {
//                                 from: { opacity: 0, transform: 'translateY(14px)' },
//                                 to: { opacity: 1, transform: 'translateY(0)' },
//                             },
//                             ...(msg.from === 'bot'
//                                 ? {
//                                     background: '#F3EEFF',
//                                     borderRadius: '4px 14px 14px 14px',
//                                     alignSelf: 'flex-start',
//                                     color: '#1A2332',
//                                 }
//                                 : {
//                                     background: 'linear-gradient(135deg, #9B7BFF, #7C5CE7)',
//                                     borderRadius: '14px 4px 14px 14px',
//                                     alignSelf: 'flex-end',
//                                     color: '#fff',
//                                 }),
//                         }}
//                     >
//                         {msg.text}
//                     </Box>
//                 ))}

//                 {/* Typing indicator */}
//                 {chatTyping && (
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             gap: '4px',
//                             padding: '10px 14px',
//                             background: '#F3EEFF',
//                             borderRadius: '4px 14px 14px 14px',
//                             alignSelf: 'flex-start',
//                             animation: 'chatFadeIn 0.2s ease-out',
//                         }}
//                     >
//                         {[0, 1, 2].map((i) => (
//                             <Box
//                                 key={i}
//                                 sx={{
//                                     width: 6,
//                                     height: 6,
//                                     background: '#9B7BFF',
//                                     borderRadius: '50%',
//                                     animation: 'typingBounce 1.4s infinite',
//                                     animationDelay: `${i * 0.2}s`,
//                                     '@keyframes typingBounce': {
//                                         '0%, 60%, 100%': { opacity: 0.3, transform: 'translateY(0)' },
//                                         '30%': { opacity: 1, transform: 'translateY(-4px)' },
//                                     },
//                                 }}
//                             />
//                         ))}
//                     </Box>
//                 )}

//                 <div ref={chatEndRef} />
//             </Box>

//             {/* Chat Input */}
//             <Box
//                 sx={{
//                     display: 'flex',
//                     gap: '8px',
//                     padding: '14px 22px',
//                     borderTop: '1px solid rgba(0,0,0,0.06)',
//                     background: '#FAFCFB',
//                 }}
//             >
//                 <input
//                     value={chatInput}
//                     onChange={(e) => setChatInput(e.target.value)}
//                     onKeyDown={(e) => {
//                         if (e.key === 'Enter') handleSendChat();
//                     }}
//                     placeholder="Type your message..."
//                     style={{
//                         flex: 1,
//                         padding: '10px 14px',
//                         border: '2px solid rgba(0,0,0,0.08)',
//                         borderRadius: '12px',
//                         fontFamily: "'DM Sans', sans-serif",
//                         fontSize: '13px',
//                         outline: 'none',
//                         transition: 'border-color 0.2s',
//                     }}
//                     onFocus={(e) => (e.target.style.borderColor = '#9B7BFF')}
//                     onBlur={(e) => (e.target.style.borderColor = 'rgba(0,0,0,0.08)')}
//                 />
//                 <Button
//                     onClick={handleSendChat}
//                     disabled={!chatInput.trim()}
//                     sx={{
//                         padding: '10px 18px',
//                         background: '#9B7BFF',
//                         color: '#fff',
//                         border: 'none',
//                         borderRadius: '12px',
//                         fontFamily: "'DM Sans', sans-serif",
//                         fontSize: 13,
//                         fontWeight: 700,
//                         textTransform: 'none',
//                         minWidth: 'auto',
//                         '&:hover': { background: '#7C5CE7' },
//                         '&:disabled': { background: '#ccc', color: '#888' },
//                     }}
//                 >
//                     <SendIcon sx={{ fontSize: 18 }} />
//                 </Button>
//             </Box>
//         </Dialog>
//     );

//     // Main render logic
//     // const mainContent = (() => {
//     //     if (!selectedDoctor) {
//     //         return renderTherapistList();
//     //     } else if (selectedDoctor && !selectedSessionType) {
//     //         return renderSessionTypeSelection();
//     //     } else if (selectedDoctor && selectedSessionType && showBookingForm) {
//     //         return renderBookingForm();
//     //     } else {
//     //         return renderSessionTypeSelection();
//     //     }
//     // })();

//     return (
//         <>

//             <>
//                 {/* Mobile Validation Modal - render at top level */}
//                 {mobileValidationOpen && (
//                     <Box
//                         sx={{
//                             position: 'fixed',
//                             top: 0,
//                             left: 0,
//                             right: 0,
//                             bottom: 0,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                             zIndex: 9999,
//                         }}
//                         onClick={handleMobileValidationClose}
//                     >
//                         <Paper
//                             sx={{
//                                 p: 4,
//                                 maxWidth: 500,
//                                 width: "90%",
//                                 borderRadius: 2,
//                                 boxShadow: 3,
//                                 background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
//                             }}
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                                 <Typography variant="h6" sx={{ fontWeight: 600, color: '#0B2D6B' }}>
//                                     Mobile Number Required
//                                 </Typography>
//                                 <IconButton onClick={handleMobileValidationClose}>
//                                     <CloseIcon />
//                                 </IconButton>
//                             </Box>
//                             <Typography variant="body1" sx={{ color: '#666', mb: 3, lineHeight: 1.6 }}>
//                                 Before booking a counselling session, please visit your profile page and ensure that your mobile number is updated.
//                             </Typography>
//                             <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
//                                 <Button
//                                     variant="outlined"
//                                     onClick={handleMobileValidationClose}
//                                     sx={{
//                                         borderColor: '#4C41FF',
//                                         color: '#4C41FF',
//                                         '&:hover': {
//                                             borderColor: '#4C41FF',
//                                             backgroundColor: 'rgba(76, 65, 255, 0.04)'
//                                         }
//                                     }}
//                                 >
//                                     Cancel
//                                 </Button>
//                                 <Button
//                                     variant="contained"
//                                     onClick={handleGoToProfile}
//                                     sx={{
//                                         background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                         '&:hover': {
//                                             background: 'linear-gradient(135deg, #16a34a, #0d9488)'
//                                         }
//                                     }}
//                                 >
//                                     Go to Profile
//                                 </Button>
//                             </Box>
//                         </Paper>
//                     </Box>
//                 )}

//                 {!selectedDoctor ? (
//                     renderTherapistList()
//                 ) : selectedDoctor && !selectedSessionType ? (
//                     renderSessionTypeSelection()
//                 ) : selectedDoctor && selectedSessionType && showBookingForm ? (
//                     renderBookingForm()
//                 ) : (
//                     renderSessionTypeSelection()
//                 )}
//             </>

//             {/* {mainContent} */}
//             {renderChatDialog()}
//         </>
//     );
// };

// export default AppointmentBooking;


//echoshine
import React, { useState, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Avatar,
    Rating,
    Button,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Select,
    FormControl,
    Stack,
    IconButton,
    Snackbar,
    Alert,
    Grid,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Paper,
    Modal,
    Tabs,
    Tab
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getAllDoctors, getDoctorSlots } from '../../service/doctor';
import StarIcon from '@mui/icons-material/Star';
import { Chip } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import BusinessIcon from '@mui/icons-material/Business';
import CloseIcon from '@mui/icons-material/Close';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import { PhoneCallback } from '@mui/icons-material';
import { listFamilyMembers } from '../../service/familyMemberService';
import { createAppointment } from '../../service/appointment';
import { getUserById } from '../../service/user';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SendIcon from '@mui/icons-material/Send';
import { trackCTA } from '../../service/usercta';

// ============== DOCTOR AVATAR COMPONENT ==============
const DoctorAvatar = ({
    doctor,
    size = 60,
    borderRadius = '50%',
    showFallback = true
}) => {
    const [imageError, setImageError] = useState(false);

    // 🎯 Map special IDs to specific images in public/photos
    const getSpecialImage = () => {
        if (doctor?.id === 11) return `/photos/Sandesh.jpeg`;
        if (doctor?.id === 12) return `/photos/Bindu-Kulkarni.jpeg`;
        if (doctor?.id === 13) return `/photos/Rohit-Malve.jpeg`;
        if (doctor?.id === 14) return `/photos/Anupam-Tiwari.jpeg`;

        return null;
    };

    // 🎨 Fallback color generator
    const getFallbackColor = () => {
        const colors = {
            4: '#FF6B6B',
            5: '#7B68EE',
            6: '#9C27B0',
            11: '#FF5722',
            12: '#4CAF50',
            15: '#2196F3',
            16: '#FF9800',
            17: '#795548',
            18: '#607D8B',
            19: '#E91E63',
        };
        return colors[doctor?.id] || '#9E9E9E';
    };

    const getInitials = () => {
        if (!doctor?.name) return '?';
        return doctor.name
            .split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    // 🖼️ Determine image URL
    // const getImageUrl = () => {
    //     const specialImage = getSpecialImage();
    //     if (specialImage) return specialImage;

    //     if (!doctor?.avatar) return null;
    //     return doctor.avatar.startsWith('http')
    //         ? doctor.avatar
    //         : `${process.env.PUBLIC_URL}${doctor.avatar}`;
    // };
    const getImageUrl = () => {
        const specialImage = getSpecialImage();
        if (specialImage) return specialImage;

        if (!doctor?.avatar) return null;
        return doctor.avatar.startsWith('http')
            ? doctor.avatar
            : `${import.meta.env.BASE_URL}${doctor.avatar.replace(/^\//, '')}`;
    };
    const handleImageError = () => {
        console.error('Failed to load avatar for:', doctor?.name);
        setImageError(true);
    };

    const imageUrl = getImageUrl();

    // 🧩 Render logic
    if (imageUrl && !imageError) {
        return (
            <Avatar
                src={imageUrl}
                alt={doctor.name}
                onError={handleImageError}
                sx={{
                    width: size,
                    height: borderRadius === 2 ? size * 1.25 : size,
                    borderRadius: borderRadius,
                    bgcolor: 'transparent',
                    border: '1px solid #e0e0e0',
                    '& .MuiAvatar-img': { objectFit: 'cover' },
                }}
            />
        );
    }

    // 🧍Fallback initials
    return (
        <Avatar
            sx={{
                width: size,
                height: borderRadius === 2 ? size * 1.25 : size,
                borderRadius: borderRadius,
                bgcolor: getFallbackColor(),
                fontSize: size > 60 ? '2rem' : '1.2rem',
                fontWeight: 'bold',
            }}
        >
            {getInitials()}
        </Avatar>
    );
};


// ============== MAIN APPOINTMENT BOOKING COMPONENT ==============
const AppointmentBooking = ({ doctorId }) => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = (localStorage.getItem("user_id") !== "null" && localStorage.getItem("user_id")) || storedUser?.id;
    const account_id = (localStorage.getItem("account_id") !== "null" && localStorage.getItem("account_id")) || storedUser?.account_id;

    const [doctors, setDoctors] = useState([]);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [recentVisits, setRecentVisits] = useState([]);
    const [showBookingForm, setShowBookingForm] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [availability, setAvailability] = useState([]);
    const [slots, setSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [selectedSessionType, setSelectedSessionType] = useState(null);
    const [accepted, setAccepted] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [selectedCategories, setSelectedCategories] = useState(['All']);
    const [mobileValidationOpen, setMobileValidationOpen] = useState(false);
    const [userData, setUserData] = useState({});

    // Dynamically generate categories from all doctors' specialties
    const categories = React.useMemo(() => {
        if (!doctors || doctors.length === 0) {
            console.log('No doctors available for categories');
            return ['All'];
        }

        console.log('Generating categories from doctors:', doctors);
        const allSpecialties = new Set();

        doctors.forEach(doctor => {
            console.log('Doctor data:', doctor);
            // Check for specialties field (could be named differently)
            const specialtiesText = doctor.specialties || doctor.specialization || doctor.specialty || '';

            if (specialtiesText) {
                const specs = specialtiesText.split(',');
                specs.forEach(specialty => {
                    const trimmed = specialty.trim();
                    if (trimmed) {
                        allSpecialties.add(trimmed);
                    }
                });
            }
        });

        const result = ['All', ...Array.from(allSpecialties).sort()];
        console.log('Generated categories:', result);
        console.log('Total unique specialties found:', allSpecialties.size);
        return result;
    }, [doctors]);

    // Chat states
    const [chatOpen, setChatOpen] = useState(false);
    const [chatDoctor, setChatDoctor] = useState(null);
    const [chatMessages, setChatMessages] = useState([]);
    const [chatInput, setChatInput] = useState('');
    const [chatTyping, setChatTyping] = useState(false);
    const chatEndRef = React.useRef(null);

    // New states for modals
    const [profileModalOpen, setProfileModalOpen] = useState(false);
    const [bookingModalOpen, setBookingModalOpen] = useState(false);
    const [modalDoctor, setModalDoctor] = useState(null);
    const [familyData, setFamilyData] = useState([]);
    const [availableDates, setAvailableDates] = useState([]); // stores dates as "YYYY-MM-DD"
    // const [userData, setUserData] = useState({});
    const [doctorData, setDoctorData] = useState(null);
    const today = new Date();
    const [currentMonth, setCurrentMonth] = useState(today.getMonth());
    const [currentYear, setCurrentYear] = useState(today.getFullYear());
    const [slotsByDate, setSlotsByDate] = useState({});
    const [slotsForSelectedDate, setSlotsForSelectedDate] = useState([]);

    useEffect(() => {
        const fetchDoctors = async () => {
            try {
                const data = await getAllDoctors(userId, account_id);       // pass it to service
                setDoctors(data?.doctors);
                setRecentVisits(data?.recent_appointments);
            } catch (err) {
                console.error("Failed to load doctors:", err);
            }
        };

        fetchDoctors();
    }, [userId]);

    // useEffect(() => {
    //     if (!showBookingForm) return;

    //     const fetchDoctorById = async () => {
    //         try {
    //             const data = await getDoctorById(selectedDoctor?.id);
    //             setDoctorData(data.doctor);
    //         } catch (err) {
    //             console.error("Failed to load doctor:", err);
    //         }
    //     };

    //     fetchDoctorById();
    // }, [showBookingForm, selectedDoctor?.id]);

    const goToNextMonth = () => {
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(prev => prev + 1);
        } else {
            setCurrentMonth(prev => prev + 1);
        }
    };

    const goToPrevMonth = () => {
        // ✅ Only allow previous if not current month/year
        if (currentYear > today.getFullYear() || (currentYear === today.getFullYear() && currentMonth > today.getMonth())) {
            if (currentMonth === 0) {
                setCurrentMonth(11);
                setCurrentYear(prev => prev - 1);
            } else {
                setCurrentMonth(prev => prev - 1);
            }
        }
    };

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const [formData, setFormData] = useState({
        full_name: "",
        age: "",
        gender: "",
        marital_status: "",
        phone: "",
        email: "",
        date: "",
        time: "",
        consultation_type: "",
        consulting_type: "self",
        dr_name: "",
        doctor_id: "",
        slots: "",
        weekly_availability: "",
        family_id: "",
        start_time: "",
        end_time: "",
    });

    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    const isSlotDisabled = (slot) => {
        const now = new Date();
        const minTime = new Date(now.getTime() + 2 * 60 * 60 * 1000); // 2-hour buffer

        // echoshine's slot objects don't always carry their own date,
        // so fall back to the currently selected date
        const slotDateStr = slot.slot_date ? slot.slot_date.split("T")[0] : selectedDate;
        const slotDateTime = new Date(`${slotDateStr}T${slot.start_time}`);

        return slotDateTime < minTime;
    };

    const formatNextAvailability = (nextAvailableSlot) => {
        if (!nextAvailableSlot || !nextAvailableSlot.slot_date || !nextAvailableSlot.start_time) {
            return "Not available";
        }

        try {
            // Parse date and time properly
            const slotDate = new Date(nextAvailableSlot.slot_date);
            const [hours, minutes] = nextAvailableSlot.start_time.split(":");

            // Merge date + time for local timezone
            slotDate.setHours(parseInt(hours), parseInt(minutes));

            // Format nicely: e.g. "31 Oct 2025, 01:00 PM"
            return slotDate.toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
        } catch (err) {
            console.error("Error formatting next availability:", err);
            return "-";
        }
    };

    // Load user from localStorage on mount
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    // Update form fields when consulting_type changes
    useEffect(() => {
        if (formData.consulting_type === "self" && user) {

            setFormData((prev) => ({
                ...prev,
                full_name: user.name || "",
                age: user.age || "",
                gender: user.gender || "",
                marital_status: user.marital_status || "",
            }));
        } else if (formData.consulting_type === "someone_else") {
            setFormData((prev) => ({
                ...prev,
                full_name: "",
                age: "",
                gender: "",
                marital_status: "",
            }));
        }
    }, [formData.consulting_type, user]);

    // useEffect(() => {
    //     if (userId && showBookingForm) {
    //         const fetchData = async () => {
    //             try {
    //                 const family = await listFamilyMembers(userId);
    //                 setFamilyData(family);
    //             } catch (err) {
    //                 console.error("Failed to fetch family members:", err);
    //             }

    //             try {
    //                 const userDetails = await getUserById(userId);
    //                 setUserData(userDetails);
    //             } catch (err) {
    //                 console.error("Failed to fetch user details:", err);
    //             }
    //         };

    //         fetchData();
    //     }
    // }, [userId, showBookingForm]);

    // Run once when component mounts or when userData is available
    useEffect(() => {
        if (userId && showBookingForm) {
            const fetchData = async () => {
                try {
                    const family = await listFamilyMembers(userId);
                    setFamilyData(family);
                } catch (err) {
                    console.error("Failed to fetch family members:", err);
                }

                try {
                    const userDetails = await getUserById(userId);
                    setUserData(userDetails);
                } catch (err) {
                    console.error("Failed to fetch user details:", err);
                }
            };

            fetchData();
        }
    }, [userId, showBookingForm]);

    useEffect(() => {
        if (formData.consulting_type === "self" && userData) {
            setFormData((prev) => ({
                ...prev,
                consulting_type: "self",
                gender: userData.gender
                    ? userData.gender.charAt(0).toUpperCase() + userData.gender.slice(1).toLowerCase()
                    : "",
                marital_status: userData.marital_status || "",
                age: userData.age || "",
                email: userData.email || "",
                phone: userData.phone || "",
                name: userData.name || "",
            }));
        }
    }, [userData]); // run when userData is loaded

    // New modal handlers
    const handleViewProfile = (doctor) => {
        setModalDoctor(doctor);
        setProfileModalOpen(true);
    };

    // const handleBookAppointment = (doctor) => {
    //     // 🔥 Track CTA event
    //     const storedUser = localStorage.getItem('user');
    //     const user = storedUser ? JSON.parse(storedUser) : null;

    //     if (user && user.id) {
    //         trackCTA('book_appointment', user, window.location.pathname);
    //         console.log("✅ CTA tracked: book_appointment");
    //     }

    //     setModalDoctor(doctor);
    //     setSelectedDoctor(doctor);
    //     setFormData(prev => ({
    //         ...prev,
    //         doctor_id: doctor.id,
    //         dr_name: doctor.name || "",
    //     }));
    //     setBookingModalOpen(false);
    // };

    const handleBookAppointment = (doctor) => {
        // 🔥 Track CTA event
        const storedUser = localStorage.getItem("user");
        const parsedUser = storedUser ? JSON.parse(storedUser) : null;
        const userId = localStorage.getItem("user_id") || parsedUser?.id || "";
        console.log("userId at click time:", userId); // 👈 check this in console

        if (user && user.id) {
            trackCTA('book_appointment', user, window.location.pathname);
            console.log("✅ CTA tracked: book_appointment");
        }

        setModalDoctor(doctor);
        setSelectedDoctor(doctor);
        setSelectedSessionType(null);
        setFormData(prev => ({
            ...prev,
            doctor_id: doctor.id,
            dr_name: doctor.name || "",
        }));
        setBookingModalOpen(false);

        // Fetch user data as soon as doctor is selected so enable_ivr is
        // available for the session type selection screen
        if (userId) {
            getUserById(userId).then(userDetails => {
                setUserData(userDetails);
            }).catch(err => {
                console.error("Failed to fetch user details:", err);
            });
        }
    };

    const handleMobileValidationClose = () => {
        setMobileValidationOpen(false);
    };

    const handleGoToProfile = () => {
        window.location.href = '/profile';
    };

    const handleCloseProfileModal = () => {
        setProfileModalOpen(false);
        setModalDoctor(null);
    };

    const handleCloseBookingModal = () => {
        setBookingModalOpen(false);
        setModalDoctor(null);
        setSelectedSessionType(null);
    };

    // Chat handlers
    // const handleOpenChat = (doctor) => {
    //     setChatDoctor(doctor);
    //     setChatMessages([
    //         {
    //             from: 'bot',
    //             text: `Welcome! 💜 You're now connected with ${doctor?.name}. This is a safe and confidential space. How can I help you today?`,
    //         },
    //     ]);
    //     setChatInput('');
    //     setChatOpen(true);
    // };

    const handleCloseChat = () => {
        setChatOpen(false);
        setChatDoctor(null);
        setChatMessages([]);
        setChatInput('');
    };

    const counsellorResponses = [
        "I hear you, and I want you to know that what you're feeling is completely valid. Can you tell me more about what's been on your mind?",
        "Thank you for sharing that with me. It takes courage to open up. Let's explore this together — what do you think triggered these feelings?",
        "That sounds really challenging. Remember, it's okay to not have all the answers right now. What would feel most supportive for you at this moment?",
        "I appreciate you trusting me with this. Many people experience similar feelings. Have you noticed any patterns in when these feelings come up?",
        "You're doing great by reaching out. Self-awareness is the first step toward positive change. What coping strategies have you tried so far?",
        "I understand. Let's take this one step at a time. Would you like to try a quick grounding exercise together, or would you prefer to keep talking?",
        "That's a really insightful observation about yourself. How does it feel to acknowledge that?",
        "It's completely normal to feel that way. Let's work through this together. What would a good outcome look like for you?",
    ];

    const handleSendChat = () => {
        const trimmed = chatInput.trim();
        if (!trimmed) return;

        setChatMessages((prev) => [...prev, { from: 'user', text: trimmed }]);
        setChatInput('');
        setChatTyping(true);

        setTimeout(() => {
            const response = counsellorResponses[Math.floor(Math.random() * counsellorResponses.length)];
            setChatMessages((prev) => [...prev, { from: 'bot', text: response }]);
            setChatTyping(false);
        }, 1200 + Math.random() * 800);
    };

    // Scroll chat to bottom on new messages
    React.useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [chatMessages, chatTyping]);

    const handleBackToList = () => {
        setShowBookingForm(false);
        setSelectedDoctor(null);
        setSelectedSessionType(null);
        setSelectedDate(null);
        setSelectedSlot(null);
    };

    useEffect(() => {
        if (availability.length > 0) {
            const newSlots = [];
            availability.forEach((slot) => {
                const start = new Date(`1970-01-01T${slot.start_time}`);
                const end = new Date(`1970-01-01T${slot.end_time}`);
                let current = new Date(start);

                while (current < end) {
                    const next = new Date(current.getTime() + 30 * 60000);
                    if (next <= end) {
                        newSlots.push(
                            `${current.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${next.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                        );
                    }
                    current = next;
                }
            });
            setSlots(newSlots);
        } else {
            setSlots([]);
        }
    }, [availability]);

    const formatSlotToAMPM = (slot) => {
        if (!slot) return ""; // safety check

        const [start, end] = slot.split("-"); // split by "-" instead of " - "
        if (!start || !end) return slot; // fallback if split fails

        const formatTime = (time24) => {
            const [hourStr, minute] = time24.split(":");
            let hour = parseInt(hourStr, 10);
            const ampm = hour >= 12 ? "PM" : "AM";
            hour = hour % 12;
            if (hour === 0) hour = 12;
            return `${hour}:${minute} ${ampm}`;
        };

        return `${formatTime(start)} - ${formatTime(end)}`;
    };

    const formatTime = (timeStr) => {
        const [hour, minute] = timeStr.split(":").map(Number);
        const ampm = hour >= 12 ? "PM" : "AM";
        const h = hour % 12 === 0 ? 12 : hour % 12;
        return `${h.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")} ${ampm}`;
    };

    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const lastDateOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const days = Array.from({ length: lastDateOfMonth }, (_, i) => i + 1);

    useEffect(() => {
        if (selectedDoctor?.id && showBookingForm) {
            const fetchSlots = async () => {
                // const startDate = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-01`;
                const today = new Date();
                // const startDate = today.toISOString().split("T")[0];
                const startDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
                const endDate = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(lastDateOfMonth).padStart(2, "0")}`;

                try {
                    const data = await getDoctorSlots(selectedDoctor?.id, startDate, endDate, false);
                    console.log("SLOTS API RESPONSE:", data);

                    // ✅ Extract date list from slots_by_date keys
                    const availableDates = Object.keys(data?.slots_by_date || {})
                        .map(date => date.split("T")[0]); // remove time part

                    setAvailableDates(availableDates);
                    setSlotsByDate(data?.slots_by_date || {});

                } catch (err) {
                    console.error(err);
                }
            };

            fetchSlots();
        }
    }, [currentMonth, currentYear, selectedDoctor?.id, lastDateOfMonth, showBookingForm]);

    //select dates automatically when available dates are fetched
    // useEffect(() => {
    //     if (availableDates.length > 0) {
    //         const firstDate = availableDates[0];
    //         setSelectedDate(firstDate);

    //         setFormData(prev => ({
    //             ...prev,
    //             date: firstDate,
    //         }));

    //         const dateKey = Object.keys(slotsByDate).find(d => d.startsWith(firstDate));
    //         const slots = dateKey ? slotsByDate[dateKey] : [];

    //         setSlotsForSelectedDate(slots); // store objects instead of formatted strings

    //         // Select first slot by default
    //         if (slots.length > 0) {
    //             const firstSlot = slots[0];
    //             setSelectedSlot(firstSlot); // full object

    //             setFormData(prev => ({
    //                 ...prev,
    //                 start_time: firstSlot.start_time,
    //                 end_time: firstSlot.end_time,
    //                 slot_id: firstSlot.id, // <-- add slot_id here
    //             }));
    //         }

    //     } else {
    //         setSelectedDate("");
    //         setSlotsForSelectedDate([]);
    //         setSelectedSlot(null);
    //         setFormData(prev => ({
    //             ...prev,
    //             date: "",
    //             start_time: "",
    //             end_time: "",
    //             slot_id: null, // reset slot_id
    //         }));
    //     }
    // }, [availableDates, slotsByDate]);

    // Reset when the doctor changes, so nothing carries over from a previous selection
    useEffect(() => {
        setSelectedDate("");
        setSelectedSlot(null);
        setSlotsForSelectedDate([]);
        setFormData(prev => ({
            ...prev,
            consulting_type: "self",
            date: "",
            start_time: "",
            end_time: "",
            slot_id: null,
        }));
    }, [selectedDoctor?.id]);

    // Reset when the month changes
    useEffect(() => {
        setSelectedDate("");
        setSlotsForSelectedDate([]);
        setSelectedSlot(null);
        setAvailableDates([]);
    }, [currentMonth, currentYear]);

    // Clear everything if there are no available dates
    useEffect(() => {
        if (availableDates.length === 0) {
            setSelectedDate("");
            setSlotsForSelectedDate([]);
            setSelectedSlot(null);
            setFormData(prev => ({
                ...prev,
                date: "",
                start_time: "",
                end_time: "",
                slot_id: null,
            }));
        }
    }, [availableDates, slotsByDate, currentMonth, currentYear]);


    useEffect(() => {
        if (slotsForSelectedDate.length === 0) {
            setSelectedSlot(null);
            setFormData(prev => ({
                ...prev,
                start_time: "",
                end_time: "",
                slot_id: null,
            }));
        }
    }, [slotsForSelectedDate]);



    // useEffect(() => {
    //     if (slotsForSelectedDate.length > 0) {
    //         const firstSlot = slotsForSelectedDate[0];
    //         setSelectedSlot(firstSlot);
    //         setFormData(prev => ({
    //             ...prev,
    //             start_time: firstSlot.start_time,
    //             end_time: firstSlot.end_time,
    //             slot_id: firstSlot.id,
    //         }));
    //     } else {
    //         setSelectedSlot("");
    //         setFormData(prev => ({
    //             ...prev,
    //             start_time: "",
    //             end_time: "",
    //             slot_id: null,
    //         }));
    //     }
    // }, [slotsForSelectedDate]);





    // const handleSubmit = async () => {
    //     // Build the request body from formData

    //     const currentYear = new Date().getFullYear();

    //     const derivedDob =
    //         userData?.dob ||
    //         (formData?.age
    //             ? `${currentYear - Number(formData.age)}-01-01`
    //             : null);

    //     console.log("age", userId, formData.family_id)
    //     const storedUser = localStorage.getItem('user');
    //     const localUser = storedUser ? JSON.parse(storedUser) : null;
    //     const appointmentData = {
    //         app_name: "echobuddy",
    //         account_id: Number(account_id),
    //         app_user_id: formData.consulting_type === "self" ? userId : `${Number(userId)}-${Number(formData.family_id)}`,
    //         name: formData.consulting_type === "self"
    //             ? (userData?.name || localUser?.name || formData?.name || formData?.full_name)
    //             : (formData?.full_name || formData?.name),
    //         email: formData.email || userData?.email || localUser?.email || "",
    //         phone: formData.phone || userData?.phone || localUser?.phone || "",
    //         address: userData?.address,
    //         dob: derivedDob,
    //         age: formData?.age,
    //         gender: formData?.gender,
    //         marital_status: formData?.marital_status,
    //         photo: userData?.photo,
    //         doctor_id: formData.doctor_id,
    //         slot_id: formData.slot_id,
    //         consultation_type: formData.consultation_type,
    //     };
    //     console.log("appointmentData", appointmentData)

    //     try {
    //         const result = await createAppointment(appointmentData);
    //         console.log("Appointment created:", result);
    //         if (window.confirm("Appointment created successfully!")) {
    //             navigate("/home"); // ✅ only if OK is clicked
    //         }
    //     } catch (err) {
    //         console.error("Failed to create appointment", err);
    //         alert("Failed to create appointment");
    //     }
    // };
    const handleSubmit = async () => {
        // ...validation checks stay the same...

        const currentYear = new Date().getFullYear();
        const derivedDob = userData?.dob
            ? userData.dob.split("T")[0]
            : (formData?.age ? `${currentYear - Number(formData.age)}-01-01` : null);

        // ✅ single source of truth — no re-parsing localStorage here
        const resolvedUserId = userData?.id || userId; // userId = top-level component var
        const resolvedAccountId = userData?.account_id || account_id;

        const appointmentData = {
            app_name: "echoshine",
            user_id: Number(resolvedUserId),
            account_id: Number(resolvedAccountId),
            customer_id: Number(resolvedUserId),   // ✅ add this

            // app_user_id:
            //     formData.consulting_type === "self"
            //         ? resolvedUserId
            //         : `${Number(resolvedUserId)}-${Number(formData.family_id)}`,
            app_user_id:
                formData.consulting_type === "self"
                    ? String(resolvedUserId)
                    : `${resolvedUserId}-${formData.family_id}`,
            name: formData.consulting_type === "self" ? userData?.name : formData?.full_name,
            email: formData.consulting_type === "self" ? userData?.email : formData?.email,
            phone: formData.consulting_type === "self" ? userData?.phone : formData?.phone,
            address: userData?.address,
            dob: derivedDob,
            // age: formData?.age,
            ...(formData?.marital_status
                ? { marital_status: formData.marital_status }
                : {}),
            gender: formData?.gender,
            // marital_status: formData?.marital_status,
            ...(formData?.marital_status
                ? { marital_status: formData.marital_status }
                : {}),
            photo: userData?.photo,
            doctor_id: formData.doctor_id,
            slot_id: formData.slot_id,
            date: formData.date,              // ✅ add
            start_time: formData.start_time,  // ✅ add
            end_time: formData.end_time,      // ✅ add
            consultation_type: formData.consultation_type,
        };

        try {
            const result = await createAppointment(appointmentData);
            if (result?.success) {
                await trackCTA(
                    "appointment-created",
                    { id: Number(resolvedUserId), account_id: Number(resolvedAccountId) },
                    "/consult/appointment"
                );
                alert("Appointment created successfully!");
                navigate("/home");
            }
        } catch (err) {
            console.error(err);
            alert("Failed to create appointment");
        }
    };
    const filteredDoctors = (() => {
        let filtered = tabValue === 0
            ? doctors?.filter((doc) => doc.id === 8) // Campus
            : doctors?.filter((doc) => doc.id !== 8); // Online

        // Apply category filter (supports multiple selections)
        if (!selectedCategories.includes('All') && selectedCategories.length > 0 && filtered) {
            filtered = filtered.filter((doc) => {
                // Check all possible specialty fields
                const specialtiesText = doc.specialties || doc.specialization || doc.specialty || '';

                if (!specialtiesText) return false;

                // Split into individual specialties
                const specialtyList = specialtiesText.split(',').map(s => s.trim().toLowerCase());

                // Check if ANY of the selected categories match ANY of the doctor's specialties
                return selectedCategories.some(selectedCategory => {
                    const categoryLower = selectedCategory.toLowerCase();
                    return specialtyList.some(specialty =>
                        specialty === categoryLower ||
                        specialty.includes(categoryLower) ||
                        categoryLower.includes(specialty)
                    );
                });
            });
        }

        return filtered;
    })();
    // const filteredDoctors = (() => {
    //     let filtered = tabValue === 0
    //         ? doctors?.filter((doc) => doc.id === 8) // Campus
    //         : doctors?.filter((doc) => doc.id !== 8); // Online

    //     // Apply category filter (supports multiple selections)
    //     if (!selectedCategories.includes('All') && selectedCategories.length > 0 && filtered) {
    //         filtered = filtered.filter((doc) => {
    //             // Check all possible specialty fields
    //             const specialtiesText = doc.specialties || doc.specialization || doc.specialty || '';

    //             if (!specialtiesText) return false;

    //             // Split into individual specialties
    //             const specialtyList = specialtiesText.split(',').map(s => s.trim().toLowerCase());

    //             // Check if ANY of the selected categories match ANY of the doctor's specialties
    //             return selectedCategories.some(selectedCategory => {
    //                 const categoryLower = selectedCategory.toLowerCase();
    //                 return specialtyList.some(specialty =>
    //                     specialty === categoryLower ||
    //                     specialty.includes(categoryLower) ||
    //                     categoryLower.includes(specialty)
    //                 );
    //             });
    //         });
    //     }

    //     return filtered;
    // })();

    // Count available doctors for each session type
    const campusCount = doctors?.filter((doc) => doc.id === 8 && doc.next_available_slot)?.length || 0;
    const onlineCount = doctors?.filter((doc) => doc.id !== 8 && doc.next_available_slot)?.length || 0;

    const renderTherapistList = () => (
        <Box sx={{ p: { xs: 2, sm: 4 }, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', minHeight: '100vh' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
                <Typography variant="h6" sx={{
                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 700,
                }}>
                    Book Your Therapy Sessions
                </Typography>
                <IconButton
                    onClick={() => navigate(-1)}
                    sx={{
                        backgroundColor: '#F0F5FF',
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        color: '#0B2D6B',
                        '&:hover': {
                            backgroundColor: '#E0EBFF'
                        }
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Box>

            {/* Session Type Selection Cards */}
            <Typography variant="subtitle2" sx={{ mb: 2, color: '#666', fontWeight: 500, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 1 }}>
                CHOOSE YOUR SESSION TYPE
            </Typography>

            <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={12} sm={6}>
                    <Card
                        onClick={() => setTabValue(0)}
                        sx={{
                            p: 3,
                            borderRadius: 3,
                            cursor: 'pointer',
                            border: tabValue === 0 ? '2px solid #22c55e' : '1px solid #e0e0e0',
                            background: tabValue === 0
                                ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)'
                                : 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: '0 8px 24px rgba(34, 197, 94, 0.15)',
                            },
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <BusinessIcon sx={{ fontSize: 32, color: tabValue === 0 ? '#22c55e' : '#666' }} />
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: tabValue === 0 ? '#22c55e' : '#0B2D6B' }}>
                                        Campus
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#666' }}>
                                        {campusCount} available
                                    </Typography>
                                </Box>
                            </Box>
                            {tabValue === 0 && (
                                <CheckCircleIcon sx={{ color: '#22c55e', fontSize: 28 }} />
                            )}
                        </Box>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Card
                        onClick={() => setTabValue(1)}
                        sx={{
                            p: 3,
                            borderRadius: 3,
                            cursor: 'pointer',
                            border: tabValue === 1 ? '2px solid #14b8a6' : '1px solid #e0e0e0',
                            background: tabValue === 1
                                ? 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)'
                                : 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: '0 8px 24px rgba(20, 184, 166, 0.15)',
                            },
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <VideocamIcon sx={{ fontSize: 32, color: tabValue === 1 ? '#14b8a6' : '#666' }} />
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: tabValue === 1 ? '#14b8a6' : '#0B2D6B' }}>
                                        Online
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#666' }}>
                                        {onlineCount} available
                                    </Typography>
                                </Box>
                            </Box>
                            {tabValue === 1 && (
                                <CheckCircleIcon sx={{ color: '#14b8a6', fontSize: 28 }} />
                            )}
                        </Box>
                    </Card>
                </Grid>
            </Grid>

            {/* Category Filter Chips */}
            {/* <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                    {categories.map((category) => {
                        const isSelected = selectedCategories.includes(category);
                        const isAll = category === 'All';
                        
                        return (
                            <Chip
                                key={category}
                                label={category}
                                onClick={() => {
                                    if (isAll) {
                                        // If 'All' is clicked, select only 'All'
                                        setSelectedCategories(['All']);
                                    } else {
                                        // If a specific category is clicked
                                        if (isSelected) {
                                            // Deselect this category
                                            const newCategories = selectedCategories.filter(c => c !== category);
                                            // If no categories left, select 'All'
                                            setSelectedCategories(newCategories.length === 0 ? ['All'] : newCategories);
                                        } else {
                                            // Select this category and remove 'All'
                                            const newCategories = selectedCategories.filter(c => c !== 'All');
                                            setSelectedCategories([...newCategories, category]);
                                        }
                                    }
                                }}
                                sx={{
                                    px: 1,
                                    py: 2.5,
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    borderRadius: 3,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    border: isSelected ? '2px solid #8b5cf6' : '1px solid #e0e0e0',
                                    backgroundColor: isSelected ? '#f3e8ff' : '#ffffff',
                                    color: isSelected ? '#8b5cf6' : '#666',
                                    '&:hover': {
                                        backgroundColor: isSelected ? '#f3e8ff' : '#f5f5f5',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 12px rgba(139, 92, 246, 0.15)',
                                    },
                                }}
                            />
                        );
                    })}
                </Box>
            </Box> */}

            {/* Recent Visits Section */}
            <Card sx={{ mb: 4, p: 3, borderRadius: 3, backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6)'
                    }} />
                    <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600 }}>
                        Recent Visits
                    </Typography>
                </Box>
                <Stack spacing={2}>
                    {recentVisits && recentVisits?.length > 0 ? (
                        recentVisits.map((visit) => (
                            <Box
                                key={visit.id}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    p: 2.5,
                                    backgroundColor: '#f9fafb',
                                    borderRadius: 3,
                                    border: '1px solid #f0f0f0',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                    <PersonIcon sx={{ color: '#666' }} />
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {visit?.dr_name}
                                        </Typography>
                                        <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
                                            <Typography variant="caption" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <CalendarTodayIcon sx={{ fontSize: 14 }} />
                                                {visit?.date
                                                    ? new Date(visit.date).toLocaleDateString('en-GB', {
                                                        day: 'numeric',
                                                        month: 'short',
                                                        year: 'numeric',
                                                    })
                                                    : ''}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <AccessTimeIcon sx={{ fontSize: 14 }} />
                                                {formatSlotToAMPM(visit?.time)}
                                            </Typography>
                                            <Chip
                                                label={visit.consultation_type.toLowerCase() === 'video'
                                                    ? 'Video Consultation'
                                                    : visit.consultation_type.toLowerCase() === 'audio'
                                                        ? 'Phone Call'
                                                        : visit.consultation_type}
                                                size="small"
                                                sx={{
                                                    height: 20,
                                                    fontSize: '0.7rem',
                                                    backgroundColor: '#E3F2FD',
                                                    color: '#1976D2'
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                                <Chip
                                    label={visit.status.charAt(0).toUpperCase() + visit.status.slice(1).toLowerCase()}
                                    size="small"
                                    sx={{
                                        backgroundColor: '#E8F5E9',
                                        color: '#4CAF50',
                                        fontWeight: 500
                                    }}
                                />
                            </Box>
                        ))) : (
                        <Typography variant="body1" sx={{ textAlign: 'center', mt: 4, color: '#777' }}>
                            No recent visits available.
                        </Typography>
                    )}
                </Stack>
            </Card>

            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 2, md: 4 },
            }}>
                {/* Left Side - Therapist List */}
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                        <Box sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #22c55e, #14b8a6)'
                        }} />
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                display: 'inline-block',
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}
                        >
                            Select Your Therapist
                        </Typography>
                    </Box>

                    <Stack spacing={2}>
                        {filteredDoctors && filteredDoctors.length > 0 ? (
                            filteredDoctors?.map((doctor) => (
                                <Card
                                    key={doctor.id}
                                    sx={{
                                        p: 3,
                                        borderRadius: 4,
                                        transition: 'all 0.3s ease',
                                        border: '1px solid #f0f0f0',
                                        background: '#ffffff',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                        '&:hover': {
                                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                            transform: 'translateY(-4px)',
                                            borderColor: '#e0e0e0',
                                        },
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        {/* Using DoctorAvatar component */}
                                        <DoctorAvatar doctor={doctor} size={60} />

                                        <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
                                                <Box>
                                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#0B2D6B', mb: 0.5 }}>
                                                        {doctor?.name}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                                                        {doctor?.profession}
                                                    </Typography>
                                                </Box>
                                                {/* <Button
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() => handleViewProfile(doctor)}
                                                    sx={{
                                                        borderColor: '#4C41FF',
                                                        color: '#4C41FF',
                                                        textTransform: 'none',
                                                        borderRadius: 2,
                                                        '&:hover': {
                                                            borderColor: '#3c32cc',
                                                            backgroundColor: '#F8F7FF'
                                                        }
                                                    }}
                                                >
                                                    View Profile
                                                </Button> */}
                                            </Box>

                                            {/* Specialization */}
                                            {doctor?.specialization && (
                                                <Typography variant="body2" sx={{ color: '#555', mb: 0.5, lineHeight: 1.6, fontWeight: 500 }}>
                                                    {doctor.specialization}
                                                </Typography>
                                            )}

                                            {/* Specialties */}
                                            {doctor?.specialties && (
                                                <Typography variant="body2" sx={{ color: '#666', mb: 1, lineHeight: 1.6 }}>
                                                    {doctor.specialties}
                                                </Typography>
                                            )}

                                            {/* Qualification */}
                                            {doctor?.qualification && (
                                                <Typography variant="body2" sx={{ color: '#666', mb: 1.5, lineHeight: 1.6 }}>
                                                    {doctor.qualification}
                                                </Typography>
                                            )}

                                            {/* {doctor?.rating && Number(doctor.rating) !== 0 && ( */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                <Rating
                                                    value={Math.min(5, Number(doctor.rating))}
                                                    precision={0.1}
                                                    readOnly
                                                    size="small"
                                                    icon={<StarIcon fontSize="inherit" />}
                                                    emptyIcon={<StarIcon fontSize="inherit" />}
                                                />

                                                <Typography variant="caption" sx={{ color: '#444' }}>
                                                    {doctor.rating}/5
                                                </Typography>


                                                {/* <Box sx={{
                                                    ml: 2,
                                                    px: 1,
                                                    py: 0.5,
                                                    borderRadius: 1,
                                                    bgcolor: doctor?.status === 'available' ? '#E8F5E8' : '#FFE8E8',
                                                    color: doctor?.status === 'available' ? '#4CAF50' : '#F44336',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 500
                                                }}>
                                                    ● {doctor?.status === 'available' ? 'Online' : 'In Session'}
                                                </Box> */}
                                            </Box>
                                            {/* )} */}

                                            <Box sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                px: 1.5,
                                                py: 0.5,
                                                borderRadius: 2,
                                                backgroundColor: doctor?.next_available_slot ? '#f0fdf4' : '#fef2f2',
                                                mb: 2
                                            }}>
                                                <Box sx={{
                                                    width: 6,
                                                    height: 6,
                                                    borderRadius: '50%',
                                                    backgroundColor: doctor?.next_available_slot ? '#22c55e' : '#ef4444',
                                                }} />
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: doctor?.next_available_slot ? '#166534' : '#991b1b',
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {doctor?.next_available_slot
                                                        ? `Next: ${formatNextAvailability(doctor.next_available_slot)}`
                                                        : 'Not available'}
                                                </Typography>
                                            </Box>

                                            {/* Action Buttons */}
                                            <Box sx={{ display: 'flex', gap: 1.5 }}>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() => handleViewProfile(doctor)}
                                                    sx={{
                                                        width: '140px', // 👈 set custom width
                                                        borderColor: '#6366f1',
                                                        borderWidth: '2px',
                                                        color: '#6366f1',
                                                        textTransform: 'none',
                                                        borderRadius: 2,
                                                        py: 0.6,
                                                        px: 2,
                                                        fontWeight: 600,
                                                        fontSize: '0.875rem',
                                                        '&:hover': {
                                                            borderColor: '#4f46e5',
                                                            borderWidth: '2px',
                                                            backgroundColor: '#eef2ff',
                                                            color: '#4f46e5',
                                                        }
                                                    }}
                                                >
                                                    View Profile
                                                </Button>

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => handleBookAppointment(doctor)}
                                                    disabled={!doctor?.next_available_slot}
                                                    sx={{
                                                        width: '180px', // 👈 set custom width
                                                        background: doctor?.next_available_slot
                                                            ? 'linear-gradient(90deg, #10b981 0%, #14b8a6 50%, #6366f1 100%)'
                                                            : '#e0e0e0',
                                                        textTransform: 'none',
                                                        borderRadius: 2,
                                                        py: 0.6,
                                                        px: 2,
                                                        fontWeight: 600,
                                                        fontSize: '0.875rem',
                                                        boxShadow: doctor?.next_available_slot
                                                            ? '0 2px 8px rgba(16, 185, 129, 0.3)'
                                                            : 'none',
                                                        '&:hover': {
                                                            background: doctor?.next_available_slot
                                                                ? 'linear-gradient(90deg, #059669 0%, #0d9488 50%, #4f46e5 100%)'
                                                                : '#e0e0e0',
                                                            boxShadow: doctor?.next_available_slot
                                                                ? '0 4px 12px rgba(16, 185, 129, 0.4)'
                                                                : 'none',
                                                        },
                                                        '&.Mui-disabled': {
                                                            backgroundColor: '#e0e0e0',
                                                            color: '#999',
                                                        },
                                                    }}
                                                >
                                                    Book Appointment
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Card>
                            ))) : (
                            <Typography variant="body1" sx={{ textAlign: 'center', mt: 4, color: '#777' }}>
                                No doctors available.
                            </Typography>
                        )}
                    </Stack>
                </Box>
            </Box>

            {/* Profile Modal */}
            <Dialog
                open={profileModalOpen}
                onClose={handleCloseProfileModal}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 600, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>
                        Counsellor Profile
                    </Typography>
                    <IconButton onClick={handleCloseProfileModal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    {modalDoctor && (
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'start', gap: 3, mb: 1 }}>
                                <Box sx={{ mt: 2 }}>
                                    <DoctorAvatar doctor={modalDoctor} size={100} />
                                </Box>
                                <Box sx={{ flex: 1, mt: 2 }}>
                                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#0B2D6B', mb: 1 }}>
                                        {modalDoctor?.name}
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>
                                        {modalDoctor?.profession}
                                    </Typography>

                                    <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                                        {modalDoctor?.specialization}
                                    </Typography>

                                    <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                                        {modalDoctor?.qualification}
                                    </Typography>

                                    {/* {modalDoctor?.rating && Number(modalDoctor.rating) !== 0 && ( */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                        <Rating
                                            value={modalDoctor?.rating}
                                            precision={0.1}
                                            readOnly
                                            size="medium"
                                        />
                                        <Typography variant="body1" sx={{ color: '#444' }}>
                                            {modalDoctor.rating}/5
                                        </Typography>
                                    </Box>
                                    {/* )} */}

                                </Box>
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 1 }}>
                                About
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.8, mb: 2 }}>
                                {modalDoctor?.description}
                            </Typography>

                            <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 1 }}>
                                Experience & Qualifications -
                            </Typography>

                            <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.8, mb: 2 }}>
                                {modalDoctor?.experience}
                            </Typography>

                            <Box sx={{ display: 'flex', gap: 2, mt: 3, justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    disabled={!modalDoctor?.next_available_slot}
                                    onClick={() => {
                                        // 🔥 Track CTA event
                                        const storedUser = localStorage.getItem('user');
                                        const user = storedUser ? JSON.parse(storedUser) : null;

                                        if (user && user.id) {
                                            trackCTA('book_appointment', user, window.location.pathname);
                                            console.log("✅ CTA tracked: book_appointment");
                                        }

                                        handleCloseProfileModal();
                                        handleBookAppointment(modalDoctor);
                                    }}
                                    sx={{
                                        minWidth: "auto",      // removes MUI default 64px width
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        textTransform: 'none',
                                        py: 1.5,
                                        borderRadius: 2,
                                        '&:hover': {
                                            backgroundColor: '#3c32cc'
                                        },
                                        '&.Mui-disabled': {
                                            backgroundColor: '#ccc', // subtle gray for disabled state
                                            color: '#666',
                                        },
                                    }}
                                >
                                    Book Appointment
                                </Button>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
            </Dialog>

            {/* Booking Modal */}
            <Dialog
                open={bookingModalOpen}
                onClose={handleCloseBookingModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Book Appointment
                    </Typography>
                    <IconButton onClick={handleCloseBookingModal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    {modalDoctor && (
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                                <DoctorAvatar doctor={modalDoctor} size={60} />
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#0B2D6B' }}>
                                        {modalDoctor.name}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#666' }}>
                                        {modalDoctor.profession || 'Lead Consultant Psychologist'}
                                    </Typography>
                                </Box>
                            </Box>

                            <Typography variant="subtitle1" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 2 }}>
                                Select Session Type
                            </Typography>

                            <Grid container spacing={2} sx={{ mb: 3 }}>
                                <Grid item xs={6}>
                                    <Card
                                        sx={{
                                            p: 2,
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            border: selectedSessionType === 'video' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                            backgroundColor: selectedSessionType === 'video' ? '#F8F7FF' : 'white',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            },
                                            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                        }}
                                        onClick={() => {
                                            setSelectedSessionType('video');
                                            setFormData(prev => ({ ...prev, consultation_type: 'video' }));
                                        }}
                                    >
                                        <VideocamIcon sx={{ fontSize: 30, color: '#666', mb: 1 }} />
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            Video Call
                                        </Typography>
                                    </Card>
                                </Grid>

                                <Grid item xs={6}>
                                    <Card
                                        sx={{
                                            p: 2,
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            border: selectedSessionType === 'in_person' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                            backgroundColor: selectedSessionType === 'in_person' ? '#F8F7FF' : 'white',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            }
                                        }}
                                        onClick={() => {
                                            setSelectedSessionType('in_person');
                                            setFormData(prev => ({ ...prev, consultation_type: 'in_person' }));
                                        }}
                                    >
                                        <BusinessIcon sx={{ fontSize: 30, color: '#666', mb: 1 }} />
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            Phone Call
                                        </Typography>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
                                Next available slot: <strong></strong>
                            </Typography>

                            <Button
                                variant="contained"
                                fullWidth
                                disabled={!selectedSessionType}
                                onClick={() => {
                                    handleCloseBookingModal();
                                    setShowBookingForm(true);
                                }}
                                sx={{
                                    height: 48,
                                    backgroundColor: '#4C41FF',
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    '&:hover': {
                                        backgroundColor: '#3c32cc',
                                    },
                                    '&:disabled': {
                                        backgroundColor: '#ccc'
                                    }
                                }}
                            >
                                Continue to Booking
                            </Button>
                        </Box>
                    )}
                </DialogContent>
            </Dialog>
        </Box >
    );

    // Session Type Selection View (after therapist selection)
    const renderSessionTypeSelection = () => (
        <Box sx={{ p: { xs: 2, sm: 4 }, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
                <Typography variant="h6" sx={{
                    fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}>
                    Book Your Therapy Session
                </Typography>
                <IconButton
                    onClick={handleBackToList}
                    sx={{
                        backgroundColor: '#F0F5FF',
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        color: '#0B2D6B',
                        '&:hover': {
                            backgroundColor: '#E0EBFF'
                        }
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 2, md: 4 },
            }}>
                {/* Left Side - Therapist List (smaller) */}
                <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" sx={{ mb: 3, color: '#0B2D6B', fontWeight: 600 }}>
                        Select Your Therapist
                    </Typography>

                    <Stack spacing={2}>
                        {doctors.map((doctor) => (
                            <Card
                                key={doctor.id}
                                sx={{
                                    p: 2,
                                    borderRadius: 3,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    border: selectedDoctor?.id === doctor.id ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                    backgroundColor: selectedDoctor?.id === doctor.id ? '#F8F7FF' : 'white',
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        transform: 'translateY(-1px)'
                                    },
                                    background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                }}
                                onClick={() => {
                                    setSelectedDoctor(doctor);
                                    setFormData(prev => ({
                                        ...prev,
                                        doctor_id: doctor.id,
                                        dr_name: doctor.name || "",
                                    }));
                                    // Reset session type when switching doctors
                                    setSelectedSessionType(null);
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    {/* Using DoctorAvatar component */}
                                    <DoctorAvatar doctor={doctor} size={50} />

                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#0B2D6B' }}>
                                            {doctor.name}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
                                            {doctor?.profession}
                                        </Typography>

                                        {/* {doctor?.rating && Number(doctor.rating) !== 0 && ( */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Rating
                                                value={doctor?.rating}
                                                precision={0.1}
                                                readOnly
                                                size="small"
                                            />
                                            <Typography variant="caption" sx={{ color: '#444' }}>
                                                {doctor?.rating}/5
                                            </Typography>
                                        </Box>
                                        {/* )} */}
                                    </Box>
                                </Box>
                            </Card>
                        ))}
                    </Stack>
                </Box>

                {/* Right Side - Doctor Profile & Session Selection */}
                <Box sx={{ flex: 1 }}>
                    {selectedDoctor && (
                        <>
                            {/* Doctor Profile - FIXED WITH AVATAR */}
                            <Box sx={{ mb: 4 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
                                    {/* Using DoctorAvatar component for profile */}
                                    <DoctorAvatar doctor={selectedDoctor} size={80} />

                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#0B2D6B', mb: 1 }}>
                                            {selectedDoctor?.name}
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>
                                            {selectedDoctor?.profession}
                                        </Typography>

                                        {/* <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
                                            {selectedDoctor?.specialization}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>
                                            {selectedDoctor?.qualification}
                                        </Typography> */}

                                        {/* {selectedDoctor?.rating && Number(selectedDoctor.rating) !== 0 && ( */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Rating
                                                value={selectedDoctor?.rating}
                                                precision={0.1}
                                                readOnly
                                                size="small"
                                            />
                                            <Typography variant="body2" sx={{ color: '#444' }}>
                                                {selectedDoctor?.rating}/5
                                            </Typography>
                                        </Box>
                                        {/* )} */}

                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                                            {(selectedDoctor?.specialties)?.split(',').map((specialty, index) => (
                                                <Chip
                                                    key={index}
                                                    label={specialty.trim()}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#E3F2FD',
                                                        color: '#1976D2',
                                                        fontSize: '0.8rem'
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>

                                {/* About Section */}
                                <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 2 }}>
                                    About {selectedDoctor?.name}
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.6, mb: 3 }}>
                                    {selectedDoctor?.description} </Typography>
                            </Box>

                            {/* Session Type Selection */}
                            <Typography variant="h6" sx={{ color: '#0B2D6B', fontWeight: 600, mb: 3 }}>
                                Select Session Type
                            </Typography>

                            {/* <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Card
                                        sx={{
                                            p: 3,
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            border: selectedSessionType === 'video' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            }
                                        }}
                                        onClick={() => {
                                            setSelectedSessionType('video');
                                            setFormData(prev => ({ ...prev, consultation_type: 'video' }));
                                            setShowBookingForm(true);
                                        }}
                                    >
                                        <VideocamIcon sx={{ fontSize: 40, color: '#666', mb: 1 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                            Video Call
                                        </Typography>

                                    </Card>
                                </Grid>

                               
                                <Grid item xs={12} sm={6}>
                                    <Card
                                        sx={{
                                            p: 3,
                                            textAlign: 'center',
                                            cursor: userData?.enable_ivr === false ? 'not-allowed' : 'pointer',
                                            height: 145,
                                            overflow: 'hidden',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: selectedSessionType === 'phone' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                            background: userData?.enable_ivr === false
                                                ? '#f9f9f9'
                                                : 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                            opacity: userData?.enable_ivr === false ? 0.7 : 1,
                                            '&:hover': userData?.enable_ivr === false
                                                ? {}
                                                : { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (userData?.enable_ivr === false) return;
                                            setSelectedSessionType('phone');
                                            setFormData(prev => ({ ...prev, consultation_type: 'audio' }));
                                            setShowBookingForm(true);
                                        }}
                                    >
                                        <PhoneCallback sx={{ fontSize: 40, color: userData?.enable_ivr === false ? '#aaa' : '#666', mb: userData?.enable_ivr === false ? 0.5 : 1 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 600, mb: userData?.enable_ivr === false ? 1 : 0 }}>
                                            Phone Call
                                        </Typography>

                                        {userData?.enable_ivr === false && (
                                            <Box
                                                sx={{
                                                    px: 1.5,
                                                    py: 0.8,
                                                    borderRadius: 1.5,
                                                    backgroundColor: '#FFF5F5',
                                                    border: '1px solid #FFCDD2',
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: 0.75,
                                                    textAlign: 'left',
                                                }}
                                            >
                                                <Box sx={{ color: '#E53935', fontSize: 14, mt: 0.15, flexShrink: 0 }}>ⓘ</Box>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#C62828',
                                                        fontSize: '0.72rem',
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    This feature is unavailable for your account. Please contact your HR for details.
                                                </Typography>
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>
                            </Grid> */}
                            <Grid container spacing={2} alignItems="stretch">
                                <Grid item xs={12} sm={6}>
                                    <Card
                                        sx={{
                                            p: 3,
                                            height: '100%',
                                            minHeight: 180,
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: selectedSessionType === 'video' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            }
                                        }}
                                        onClick={() => {
                                            setSelectedSessionType('video');
                                            setFormData(prev => ({ ...prev, consultation_type: 'video' }));
                                            setShowBookingForm(true);
                                        }}
                                    >
                                        <VideocamIcon sx={{ fontSize: 40, color: '#666', mb: 1.5 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                            Video Call
                                        </Typography>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Card
                                        sx={{
                                            p: 3,
                                            height: '100%',
                                            minHeight: 180,
                                            textAlign: 'center',
                                            cursor: userData?.enable_ivr === false ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 1,
                                            border: selectedSessionType === 'phone' ? '2px solid #4C41FF' : '1px solid #e0e0e0',
                                            background: userData?.enable_ivr === false
                                                ? '#f9f9f9'
                                                : 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                            opacity: userData?.enable_ivr === false ? 0.85 : 1,
                                            transition: 'all 0.2s',
                                            '&:hover': userData?.enable_ivr === false
                                                ? {}
                                                : { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (userData?.enable_ivr === false) return;
                                            setSelectedSessionType('phone');
                                            setFormData(prev => ({ ...prev, consultation_type: 'audio' }));
                                            setShowBookingForm(true);
                                        }}
                                    >
                                        <PhoneCallback sx={{ fontSize: 40, color: userData?.enable_ivr === false ? '#aaa' : '#666' }} />
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                            Phone Call
                                        </Typography>

                                        {userData?.enable_ivr === false && (
                                            <Box
                                                sx={{
                                                    mt: 0.5,
                                                    px: 1.5,
                                                    py: 1,
                                                    borderRadius: 1.5,
                                                    backgroundColor: '#FFF5F5',
                                                    border: '1px solid #FFCDD2',
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    gap: 0.75,
                                                    textAlign: 'left',
                                                    width: '100%',
                                                }}
                                            >
                                                <Box sx={{ color: '#E53935', fontSize: 14, mt: 0.15, flexShrink: 0 }}>ⓘ</Box>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#C62828',
                                                        fontSize: '0.72rem',
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    This feature is unavailable for your account. Please contact your HR for details.
                                                </Typography>
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>
                            </Grid>

                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );

    // Original Booking Form (when showBookingForm is true and selectedSessionType is set)
    const renderBookingForm = () => (
        <Box sx={{ background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
            <Box sx={{ p: { xs: 2, sm: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>
                        Book Your Sessions
                    </Typography>
                    <IconButton
                        onClick={() => setShowBookingForm(false)}
                        sx={{
                            backgroundColor: '#F0F5FF',
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            color: '#0B2D6B',
                            '&:hover': {
                                backgroundColor: '#E0EBFF'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </Box>

                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: { xs: 2, md: 4 },

                }}>
                    {/* Left Card - Date & Time Selection */}
                    <Card sx={{ flex: 1, borderRadius: 3, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
                        <CardContent>
                            {/* Date Picker */}
                            <Typography
                                variant="subtitle1"
                                sx={{ color: "#103680", fontSize: '14px', fontWeight: 500, mt: 3 }}
                            >
                                Select Date
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1, justifyContent: "space-between" }}>
                                <IconButton
                                    onClick={goToPrevMonth}
                                    disabled={currentYear === today.getFullYear() && currentMonth === today.getMonth()}
                                    sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
                                >
                                    <ArrowBackIosNewIcon fontSize="small" />
                                </IconButton>

                                <Typography sx={{ fontSize: '16px', fontWeight: 600, minWidth: 120, textAlign: "center" }}>
                                    {new Date(currentYear, currentMonth).toLocaleString("default", {
                                        month: "long",
                                        year: "numeric",
                                    })}
                                </Typography>

                                <IconButton
                                    onClick={goToNextMonth}
                                    sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
                                >
                                    <ArrowForwardIosIcon fontSize="small" />
                                </IconButton>
                            </Box>

                            <Box sx={{ p: 1 }}>
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: { xs: "repeat(4, 1fr)", md: "repeat(7, 1fr)" },
                                        gap: { xs: 0.5, md: 2 },
                                        p: 1,
                                    }}
                                >
                                    {/* Weekday headers */}
                                    {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, i) => (
                                        <Typography
                                            key={day}
                                            variant="body2"
                                            sx={{
                                                textAlign: "center",
                                                color: "#000",
                                                fontWeight: 500,
                                                display: { xs: i < 4 ? "block" : "none", md: "block" },
                                            }}
                                        >
                                            {day}
                                        </Typography>
                                    ))}

                                    {/* Empty slots before month starts */}
                                    {[...Array(firstDayOfMonth)].map((_, idx) => (
                                        <Box key={`empty-${idx}`} />
                                    ))}

                                    {/* Days */}
                                    {days.map((day) => {
                                        const fullDate = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                                        const isAvailable = availableDates.includes(fullDate);

                                        return (
                                            <Box
                                                key={day}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Button
                                                    disabled={!isAvailable}
                                                    onClick={() => {
                                                        setSelectedDate(fullDate); // store full date
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            date: fullDate,
                                                        }));

                                                        // ✅ Log slots for this date
                                                        const dateKey = Object.keys(slotsByDate).find(d => d.startsWith(fullDate));
                                                        const slots = dateKey ? slotsByDate[dateKey] : [];

                                                        // const formattedSlots = slots.map(slot =>
                                                        //     `${formatTime(slot.start_time)} to ${formatTime(slot.end_time)}`
                                                        // );
                                                        // setSlotsForSelectedDate(formattedSlots);
                                                        setSlotsForSelectedDate(slots);

                                                    }}
                                                    sx={{
                                                        width: "70%",
                                                        aspectRatio: "1 / 1",
                                                        borderRadius: 5,
                                                        backgroundColor: selectedDate === fullDate
                                                            ? "#4C41FF"
                                                            : isAvailable
                                                                ? "#FBFBFB"
                                                                : "#e0e0e0",
                                                        color: selectedDate === fullDate
                                                            ? "#fff"
                                                            : isAvailable
                                                                ? "#4C41FF"
                                                                : "#aaa",
                                                        fontWeight: selectedDate === fullDate ? 600 : 400,
                                                        fontSize: "14px",
                                                        textTransform: "none",
                                                        "&:hover": {
                                                            backgroundColor: isAvailable
                                                                ? selectedDate === fullDate
                                                                    ? "#3c32cc"
                                                                    : "#f5f5f5"
                                                                : "#e0e0e0",
                                                        },
                                                    }}
                                                >
                                                    {day}
                                                </Button>
                                            </Box>
                                        );
                                    })}

                                </Box>
                            </Box>

                            {/* Time Slots */}
                            <Box>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ mb: 2, color: '#103680', fontWeight: 550, mt: 4 }}
                                >
                                    Available Slot
                                </Typography>

                                {/* Render available slots for selected date */}
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    {slotsForSelectedDate.length === 0 ? (
                                        <Typography variant="body2" sx={{ color: '#888' }}>
                                            {/* No slots available */}
                                            {!selectedDate
                                                ? "Please select a date to view available slots"
                                                : "No slots available for the selected date"}
                                        </Typography>
                                    ) : (
                                        slotsForSelectedDate.map((slot, idx) => (
                                            <Button
                                                key={idx}
                                                variant={selectedSlot === slot ? 'contained' : 'outlined'}
                                                color="primary"
                                                size="small"
                                                disabled={isSlotDisabled(slot)}
                                                onClick={() => {
                                                    setSelectedSlot(slot);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        start_time: slot.start_time,
                                                        end_time: slot.end_time,
                                                        slot_id: slot.id,
                                                    }));
                                                }}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: 2,
                                                    minWidth: '100px',
                                                }}
                                            >
                                                {`${slot.start_time.slice(0, 5)} - ${slot.end_time.slice(0, 5)}`}
                                            </Button>
                                        ))
                                    )}
                                </Box>

                            </Box>

                        </CardContent>
                    </Card>

                    {/* Right Card - Patient Information */}
                    <Card sx={{ flex: 1, borderRadius: 3, background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
                        <CardContent>
                            <Card
                                elevation={3}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 3,
                                    p: 2,
                                    mb: 3,
                                    borderRadius: 3,
                                    background: 'linear-gradient(135deg, #F0F5FF 0%, #ffffff 100%)',
                                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
                                }}
                            >
                                <DoctorAvatar doctor={selectedDoctor} size={80} borderRadius={2} />

                                {selectedDoctor && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#103680' }}>
                                            {selectedDoctor.name}
                                        </Typography>

                                        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                                            {selectedDoctor.profession || 'Psychotherapist & Hypnotherapist'}
                                        </Typography>

                                        {/* {selectedDoctor?.rating && Number(selectedDoctor.rating) !== 0 && ( */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                            <Rating
                                                value={selectedDoctor.rating ?? 0}
                                                precision={0.1}
                                                readOnly
                                                size="small"
                                                icon={<StarIcon fontSize="inherit" />}
                                                emptyIcon={<StarIcon fontSize="inherit" />}
                                            />
                                            <Typography variant="caption" sx={{ color: '#444' }}>
                                                {selectedDoctor.rating ?? 0}/5
                                            </Typography>
                                        </Box>
                                        {/* )} */}

                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
                                            {selectedDoctor.specialties?.split(',').map((specialty, index) => (
                                                <Chip
                                                    key={index}
                                                    label={specialty.trim()}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#E3F2FD',
                                                        color: '#1976D2',
                                                        fontSize: '0.7rem',
                                                        height: 20
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                            </Card>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                                    gap: 2,
                                    mt: 1,
                                }}
                            >
                                <Box>
                                    <Typography variant="subtitle1" sx={{ mb: 1, color: '#103680', fontWeight: 550 }}>
                                        Consultation Type
                                    </Typography>
                                    <FormControl fullWidth>
                                        <Select
                                            name="consultation_type"
                                            displayEmpty
                                            value={formData.consultation_type}
                                            onChange={(e) => setFormData({ ...formData, consultation_type: e.target.value })}
                                            sx={{ height: 45, borderRadius: 2 }}
                                        >
                                            <MenuItem value="audio">Phone Call</MenuItem>
                                            <MenuItem value="video">Video Call</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>

                                <Box>
                                    <Typography variant="subtitle1" sx={{ mb: 1, color: "#103680", fontWeight: 550 }}>
                                        Consulting for
                                    </Typography>

                                    <FormControl fullWidth>
                                        <Select
                                            name="consulting_type"
                                            displayEmpty
                                            value={formData.consulting_type}
                                            onChange={(e) => {
                                                const selectedName = e.target.value;

                                                if (selectedName === "self" && userData) {
                                                    // If "Self" is selected, populate formData with current user data
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        consulting_type: "self",
                                                        gender: userData.gender ? userData.gender.charAt(0).toUpperCase() + userData.gender.slice(1).toLowerCase() : "",
                                                        marital_status: userData.marital_status || "",
                                                        age: userData.age || "",
                                                        email: userData.email || "",
                                                        phone: userData.phone || "",
                                                        name: userData.name || "",
                                                    }));
                                                } else {
                                                    // Populate formData with selected family member data
                                                    const selectedMember = familyData.find((m) => m.name === selectedName);
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        consulting_type: selectedName,
                                                        gender: selectedMember?.gender ? selectedMember.gender.charAt(0).toUpperCase() + selectedMember.gender.slice(1).toLowerCase() : "",
                                                        marital_status: selectedMember?.relationship || "",
                                                        age: selectedMember?.age || "",
                                                        email: selectedMember?.email || "",
                                                        phone: selectedMember?.contact || "",
                                                        full_name: selectedMember?.name || "",
                                                        family_id: selectedMember?.id,
                                                    }));
                                                }
                                            }}
                                            sx={{ height: 45, borderRadius: 2 }}
                                        >
                                            <MenuItem value="self">Self</MenuItem>
                                            {familyData.length > 0 &&
                                                familyData.map((member) => (
                                                    <MenuItem key={member.id} value={member.name}>
                                                        {member.name} ({member.relationship})
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>

                                </Box>
                            </Box>
                            {formData.consultation_type === 'audio' && (() => {
                                const isSelf = formData.consulting_type === 'self';
                                const phone = isSelf ? userData?.phone : formData.phone;
                                const hasPhone = phone && phone.trim() !== '';
                                if (hasPhone) return null;
                                return (
                                    <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }}>
                                        {isSelf
                                            ? 'A phone number is required for Phone Call consultations. '
                                            : 'A phone number is required for Phone Call consultations. '}
                                        <span
                                            onClick={() => navigate(isSelf ? '/profile' : '/family')}
                                            style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline' }}
                                        >
                                            {isSelf ? 'Update your profile' : 'Update family member profile'}
                                        </span>
                                        {' to add a valid phone number before proceeding.'}
                                    </Alert>
                                );
                            })()}
                            <Typography
                                variant="subtitle1"
                                sx={{ mt: 7, mb: 2, color: "#103680", fontSize: "18px", fontWeight: 500 }}
                            >
                                Patient Information
                            </Typography>

                            <Paper
                                elevation={3}
                                sx={{
                                    p: 4,
                                    borderRadius: 3,
                                    bgcolor: 'grey.50',
                                    maxWidth: 600,
                                    mx: 'auto',
                                }}
                            >
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                    {[
                                        { label: 'Full Name', value: formData.name },
                                        { label: 'Age', value: formData.age },
                                        { label: 'Gender', value: formData.gender },
                                        {
                                            label: 'Marital Status',
                                            value: formData.marital_status
                                                ? formData.marital_status.charAt(0).toUpperCase() +
                                                formData.marital_status.slice(1)
                                                : '-',
                                        },
                                    ].map((item) => (
                                        <Box
                                            key={item.label}
                                            sx={{
                                                flex: '1 1 48%',
                                                p: 1.5,
                                                borderRadius: 2,
                                                bgcolor: 'white',
                                                boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: '#666',
                                                    fontWeight: 500,
                                                    mb: 0.5,
                                                }}
                                            >
                                                {item.label}
                                            </Typography>

                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color: '#333',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {item.value || '-'}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Paper>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disableRipple
                                        checked={accepted}
                                        onChange={(e) => {
                                            setOpenModal(true); // 👈 Open modal whenever checkbox is clicked
                                        }}
                                        icon={
                                            <Box
                                                sx={{
                                                    width: 20,
                                                    height: 20,
                                                    border: "1px solid rgba(0,0,0,0.6)",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                        }
                                        checkedIcon={
                                            <Box
                                                sx={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: "#F5F5F5",
                                                    borderRadius: "4px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <CheckIcon sx={{ fontSize: 18, color: "#000" }} />
                                            </Box>
                                        }
                                    />
                                }
                                label={
                                    <span>
                                        I accept the{" "}
                                        <Box
                                            component="span"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenModal(true);
                                            }}
                                            sx={{
                                                cursor: "pointer",
                                                textDecoration: "underline",
                                                color: "primary.main",
                                                "&:hover": { textDecoration: "none" },
                                            }}
                                        >
                                            Terms & Conditions and Privacy Policy
                                        </Box>
                                    </span>

                                }
                                sx={{ mt: 3 }}
                            />

                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        height: 50,
                                        mt: 2,
                                        background:
                                            accepted && selectedDate && selectedSlot
                                                ? 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
                                                : '#ccc',
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        minWidth: 'auto',

                                        '&:hover': {
                                            background:
                                                accepted && selectedDate && selectedSlot
                                                    ? 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
                                                    : '#ccc',
                                        },

                                        '&:disabled': {
                                            background: '#ccc',
                                            color: '#888',
                                        },
                                    }}
                                    disabled={!accepted || !selectedDate || !selectedSlot || (formData.consultation_type === 'audio' && (() => { const p = formData.consulting_type === 'self' ? userData?.phone : formData.phone; return !p || p.trim() === ''; })())}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Card sx={{ width: 300, height: 100, backgroundColor: '#fefefe', boxShadow: 3, p: 2 }}>
                        <Alert
                            onClose={handleClose}
                            severity={snackbar.severity}
                            sx={{ width: '100%' }}
                        >
                            <Typography variant="body1">
                                {snackbar.message}
                            </Typography>
                        </Alert>
                    </Card>
                </Snackbar>

                <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <Box
                        sx={{
                            height: "100vh",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Paper
                            sx={{
                                p: 3,
                                maxWidth: 800,
                                width: "90%",
                                maxHeight: "80vh",
                                borderRadius: 2,
                                outline: "none",
                                position: "relative", // ✅ For close icon positioning
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* ✅ Close Icon */}
                            <IconButton
                                onClick={() => setOpenModal(false)}
                                sx={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                    color: "#555",
                                    "&:hover": { backgroundColor: "transparent", color: "#000" },
                                }}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography variant="h6" sx={{ mb: 2, pr: 4 }}>
                                Terms & Conditions
                            </Typography>
                            <Divider sx={{ mb: 2 }} />

                            <Typography
                                sx={{
                                    mb: 2,
                                    flex: 1,
                                    overflowY: "auto",
                                    fontSize: 14,
                                    color: "#444",
                                }}
                            >
                                {/* Point 1 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>1. Confidentiality & Privacy Protection:</strong> I understand that all personal information and session content will be kept strictly confidential, stored securely with end-to-end encryption, and will not be shared without my written consent except when legally mandated (risk of harm, court orders, child protection).
                                </Box>

                                {/* Point 2 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>2. Nature & Limitations of Online Services:</strong> I acknowledge the limitations of online therapy including potential technical issues, reduced non-verbal observation, and that it may not be suitable for severe psychiatric conditions. I agree to maintain a private environment during sessions.
                                </Box>

                                {/* Point 3 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>3. Voluntary Participation:</strong> I am seeking these services voluntarily and understand I can pause or discontinue at any time without penalty. I can decline to answer questions or discuss topics.
                                </Box>

                                {/* Point 4 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>4. Services Scope & Outcomes:</strong> The sessions may include psychological assessments, sound therapy, emotional support, behavioral guidance, wellness coaching, or clinical counselling. I understand that the expected outcome of therapy is not cure but is meant for care and support.
                                </Box>

                                {/* Point 5 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>5. NOT a Crisis or Emergency Service:</strong> I understand this is NOT a crisis service. In emergencies, I will contact 112, visit the nearest hospital, call crisis helplines (NIMHANS: 080-46110007, Vandrevala: 1860-2662-345, iCall: 9152987821), or contact the emergency number provided on the app.
                                </Box>

                                {/* Point 6 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>6. Record-Keeping & Data Storage:</strong> I consent to secure digital storage of clinical records for continuity of care, compliant with IT Act 2000. Records will be retained for 7 years. I have the right to access my records.
                                </Box>

                                {/* Point 7 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>7. Technical Requirements:</strong> I confirm I have stable internet, compatible device, updated echoBuddy app, and a private space. I am responsible for my technical setup.
                                </Box>

                                {/* Point 8 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>8. Professional Boundaries:</strong> I understand that the relationship with my counsellor is strictly professional and therapeutic in nature. Contact will be limited to scheduled sessions and communication through the echoBuddy platform.
                                </Box>

                                {/* Point 9 */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <strong>9. Consent Validity:</strong> This consent is valid for all my appointments and counselling sessions through echoBuddy. I understand I can withdraw this consent at any time by providing written notice through the app or email. The consent will remain in effect until I choose to withdraw it.
                                </Box>

                                {/* Declaration */}
                                <Box
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        border: "1px solid #bbb",
                                        borderRadius: 2,
                                        backgroundColor: "#f1f1f1",
                                    }}
                                >
                                    <strong>Declaration & Consent:</strong>
                                    <br /><br />

                                    {/* ✅ Each point with circular icon */}
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                        <Box
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd", // light blue background
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mr: 1.5,
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} /> {/* Blue icon */}
                                        </Box>
                                        I have read and understood all terms and conditions above.
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                        <Box
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mr: 1.5,
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                                        </Box>
                                        I am voluntarily consenting to receive psychological counselling services.
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                        <Box
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mr: 1.5,
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                                        </Box>
                                        I understand the nature, benefits, risks, and limitations of online therapy.
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                        <Box
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mr: 1.5,
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                                        </Box>
                                        I understand that the expected outcome of therapy is not cure but is meant for care and support.
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                        <Box
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mr: 1.5,
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                                        </Box>
                                        I understand this is not an emergency service.
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Box
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                backgroundColor: "#e3f2fd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mr: 1.5,
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ fontSize: 18, color: "#1976d2" }} />
                                        </Box>
                                        I understand this consent applies to all my appointments with echoBuddy.
                                    </Box>
                                </Box>

                                {/* I AGREE section */}
                                <Box
                                    sx={{
                                        p: 2,
                                        pt: 1,
                                        border: "1px solid #aaa",
                                        borderRadius: 2,
                                        backgroundColor: "#e9f5ff",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            my: 1
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                setAccepted(true);
                                                setOpenModal(false);
                                            }}
                                            sx={{
                                                textTransform: "none",
                                                px: 1.5,          // smaller horizontal padding
                                                py: 0.5,          // smaller vertical padding
                                                fontSize: 12,     // smaller text
                                                fontWeight: 500,
                                                borderRadius: 1.5,
                                                minWidth: 70,     // smaller width
                                                height: 30,       // set explicit height
                                            }}
                                        >
                                            I AGREE
                                        </Button>
                                    </Box>

                                    By reading this form, I provide my informed consent to receive psychological counselling services through echoBuddy for all my appointments, and I confirm that I have read and agree to all the terms and conditions mentioned above. This consent remains valid for all future sessions unless I withdraw it in writing.
                                </Box>
                            </Typography>
                        </Paper>
                    </Box>
                </Modal>
            </Box>
        </Box>
    );

    // Chat Dialog Component
    const renderChatDialog = () => (
        <Dialog
            open={chatOpen}
            onClose={handleCloseChat}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    overflow: 'hidden',
                    height: '600px',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            {/* Chat Header */}
            <Box
                sx={{
                    padding: '14px 22px',
                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                }}
            >
                <Box
                    sx={{
                        width: 38,
                        height: 38,
                        background: 'rgba(255,255,255,0.2)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 18,
                    }}
                >
                    👩‍⚕️
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography
                        sx={{
                            fontFamily: "'Outfit', sans-serif",
                            fontSize: 16,
                            fontWeight: 700,
                        }}
                    >
                        {chatDoctor?.name || 'Counsellor'}
                    </Typography>
                    <Typography sx={{ fontSize: 11, opacity: 0.85 }}>
                        <Box
                            component="span"
                            sx={{
                                width: 7,
                                height: 7,
                                background: '#4ADE80',
                                borderRadius: '50%',
                                display: 'inline-block',
                                mr: 0.5,
                            }}
                        />
                        Live chat · Confidential & safe
                    </Typography>
                </Box>
                <IconButton onClick={handleCloseChat} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Chat Messages */}
            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '18px 22px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    background: '#FAFCFB',
                }}
            >
                {chatMessages.map((msg, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            maxWidth: '80%',
                            padding: '11px 15px',
                            fontSize: 13,
                            lineHeight: 1.5,
                            animation: 'chatFadeIn 0.3s ease-out',
                            '@keyframes chatFadeIn': {
                                from: { opacity: 0, transform: 'translateY(14px)' },
                                to: { opacity: 1, transform: 'translateY(0)' },
                            },
                            ...(msg.from === 'bot'
                                ? {
                                    background: '#F3EEFF',
                                    borderRadius: '4px 14px 14px 14px',
                                    alignSelf: 'flex-start',
                                    color: '#1A2332',
                                }
                                : {
                                    background: 'linear-gradient(135deg, #9B7BFF, #7C5CE7)',
                                    borderRadius: '14px 4px 14px 14px',
                                    alignSelf: 'flex-end',
                                    color: '#fff',
                                }),
                        }}
                    >
                        {msg.text}
                    </Box>
                ))}

                {/* Typing indicator */}
                {chatTyping && (
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '4px',
                            padding: '10px 14px',
                            background: '#F3EEFF',
                            borderRadius: '4px 14px 14px 14px',
                            alignSelf: 'flex-start',
                            animation: 'chatFadeIn 0.2s ease-out',
                        }}
                    >
                        {[0, 1, 2].map((i) => (
                            <Box
                                key={i}
                                sx={{
                                    width: 6,
                                    height: 6,
                                    background: '#9B7BFF',
                                    borderRadius: '50%',
                                    animation: 'typingBounce 1.4s infinite',
                                    animationDelay: `${i * 0.2}s`,
                                    '@keyframes typingBounce': {
                                        '0%, 60%, 100%': { opacity: 0.3, transform: 'translateY(0)' },
                                        '30%': { opacity: 1, transform: 'translateY(-4px)' },
                                    },
                                }}
                            />
                        ))}
                    </Box>
                )}

                <div ref={chatEndRef} />
            </Box>

            {/* Chat Input */}
            <Box
                sx={{
                    display: 'flex',
                    gap: '8px',
                    padding: '14px 22px',
                    borderTop: '1px solid rgba(0,0,0,0.06)',
                    background: '#FAFCFB',
                }}
            >
                <input
                    value={chatInput}
                    onChange={(e) => setChatInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSendChat();
                    }}
                    placeholder="Type your message..."
                    style={{
                        flex: 1,
                        padding: '10px 14px',
                        border: '2px solid rgba(0,0,0,0.08)',
                        borderRadius: '12px',
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: '13px',
                        outline: 'none',
                        transition: 'border-color 0.2s',
                    }}
                    onFocus={(e) => (e.target.style.borderColor = '#9B7BFF')}
                    onBlur={(e) => (e.target.style.borderColor = 'rgba(0,0,0,0.08)')}
                />
                <Button
                    onClick={handleSendChat}
                    disabled={!chatInput.trim()}
                    sx={{
                        padding: '10px 18px',
                        background: '#9B7BFF',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: 13,
                        fontWeight: 700,
                        textTransform: 'none',
                        minWidth: 'auto',
                        '&:hover': { background: '#7C5CE7' },
                        '&:disabled': { background: '#ccc', color: '#888' },
                    }}
                >
                    <SendIcon sx={{ fontSize: 18 }} />
                </Button>
            </Box>
        </Dialog>
    );

    // Main render logic
    // const mainContent = (() => {
    //     if (!selectedDoctor) {
    //         return renderTherapistList();
    //     } else if (selectedDoctor && !selectedSessionType) {
    //         return renderSessionTypeSelection();
    //     } else if (selectedDoctor && selectedSessionType && showBookingForm) {
    //         return renderBookingForm();
    //     } else {
    //         return renderSessionTypeSelection();
    //     }
    // })();

    return (
        <>

            <>
                {/* Mobile Validation Modal - render at top level */}
                {mobileValidationOpen && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 9999,
                        }}
                        onClick={handleMobileValidationClose}
                    >
                        <Paper
                            sx={{
                                p: 4,
                                maxWidth: 500,
                                width: "90%",
                                borderRadius: 2,
                                boxShadow: 3,
                                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#0B2D6B' }}>
                                    Mobile Number Required
                                </Typography>
                                <IconButton onClick={handleMobileValidationClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <Typography variant="body1" sx={{ color: '#666', mb: 3, lineHeight: 1.6 }}>
                                Before booking a counselling session, please visit your profile page and ensure that your mobile number is updated.
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button
                                    variant="outlined"
                                    onClick={handleMobileValidationClose}
                                    sx={{
                                        borderColor: '#4C41FF',
                                        color: '#4C41FF',
                                        '&:hover': {
                                            borderColor: '#4C41FF',
                                            backgroundColor: 'rgba(76, 65, 255, 0.04)'
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleGoToProfile}
                                    sx={{
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        '&:hover': {
                                            background: 'linear-gradient(135deg, #16a34a, #0d9488)'
                                        }
                                    }}
                                >
                                    Go to Profile
                                </Button>
                            </Box>
                        </Paper>
                    </Box>
                )}

                {!selectedDoctor ? (
                    renderTherapistList()
                ) : selectedDoctor && !selectedSessionType ? (
                    renderSessionTypeSelection()
                ) : selectedDoctor && selectedSessionType && showBookingForm ? (
                    renderBookingForm()
                ) : (
                    renderSessionTypeSelection()
                )}
            </>

            {/* {mainContent} */}
            {renderChatDialog()}
        </>
    );
};

export default AppointmentBooking;